export const CANALE_AGG_PROPS = [
  { label: 'Batch', key: '3' },
  { label: 'Online', key: '4' },
  { label: 'Applicazione', key: '5' }
];

export const TIPO_EMISSIONE_CARTA_PROPS = [
  { label: 'Immatricolazione', key: 'I' },
  { label: 'Reimmatricolazione', key: 'R' },
  { label: 'Duplicato', key: 'D' },
  { label: 'Passaggi di proprietà effettuati prima dell’iscrizione al PRA', key: 'G' },
  { label: 'Cambio carrozzeria', key: 'C' },
  { label: 'Cambio carrozzeria a seguito visita e prova', key: 'K' },
  { label: 'Cambio uso', key: 'U' },
  { label: 'Visita e prova', key: 'W' },
  { label: 'Tagliando', key: 'T' }
];

export const CAUSALE_ACI_PROPS = [
  { label: 'DETERIORAMENTO', key: 'C02105' },
  { label: 'SMARRIMENTO', key: 'C02104' },
  { label: 'FURTO', key: 'C02102' },
  { label: 'DISTRUZIONE TARGA', key: 'C02101' },
  { label: 'DUPLICATO DU - VARIAZIONE DATI', key: 'C18807' },
  { label: 'RISTAMPA DU - RETTIFICA DATI', key: 'C18806' },
  { label: 'STAMPA DU - POST VARIAZIONE DATI TECNICI', key: 'C18812' },
  { label: 'DA CdC DETERIORAMENTO', key: 'C18811' },
  { label: 'DA CdC FURTO E SMARRIMENTO', key: 'C18810' },
  { label: 'STAMPA DU - POST VARIAZIONE DATI', key: 'C18808' },
  { label: 'STAMPA DOCUMENTO UNICO', key: 'C18805' },
  { label: 'ELIMINAZIONE ANNOTAZIONI PROVVISORIE', key: 'C18804' },
  { label: 'DETERIORAMENTO O DISTRUZIONE', key: 'C18803' },
  { label: 'SMARRIMENTO', key: 'C18802' },
  { label: 'FURTO E SMARRIMENTO', key: 'C18801' },
  { label: 'COSTITUZIONE DI USUFRUTTO', key: 'C02601' },
  { label: 'ISCRIZIONE', key: 'C08701' },
  { label: 'PROPRIETÀ', key: 'C01501' },
  { label: 'LOCAZIONE', key: 'C01502' },
  { label: 'USUFRUTTO', key: 'C01504' },
  { label: 'PATTO RISERVATO DOMINIO', key: 'C01503' },
  { label: 'MINI VOLTURA', key: 'C03305' },
  { label: 'PROPRIETÀ', key: 'C03301' },
  { label: 'USUFRUTTO', key: 'C03303' },
  { label: 'LOCAZIONE', key: 'C03302' },
  { label: 'PATTO RISERVATO DOMINIO', key: 'C03304' },
  { label: 'SUCCESSIONE EREDITARIA', key: 'C03306' },
  { label: 'DEMOLIZIONE', key: 'C05308' },
  { label: 'CESSAZIONE CIRCOLAZIONE PER ESPORTAZIONE', key: 'C05331' },
  { label: 'ESPORTAZIONE VERSO UNIONE EUROPEA', key: 'C05315' },
  { label: 'ESPORTAZIONE EXTRA UNIONE EUROPEA CON RICEVUTA', key: 'C05314' },
  { label: 'UE - LOCAZIONE', key: 'C11703' },
  { label: 'UE - USUFRUTTO', key: 'C11705' },
  { label: 'VEICOLO USATO RADIATO IN ITALIA - USUFRUTTO', key: 'C01726' },
  { label: 'VEICOLO USATO RADIATO IN ITALIA - PATTO RISERVATO DOMINIO', key: 'C01725' },
  { label: 'VEICOLO USATO RADIATO IN ITALIA - LOCAZIONE', key: 'C01724' },
  { label: 'VEICOLO USATO RADIATO IN ITALIA - PROPRIETA', key: 'C01723' },
  { label: 'CORPO SPECIALE - USUFRUTTO', key: 'C01716' },
  { label: 'CORPO SPECIALE - PATTO RISERVATO DOMINIO', key: 'C01715' },
  { label: 'CORPO SPECIALE - LOCAZIONE', key: 'C01714' },
  { label: 'RISTAMPA DU - MINI VOLTURA', key: 'C01713' },
  { label: 'CORPO SPECIALE - PROPRIETA', key: 'C01712' },
  { label: 'Extra UE - USUFRUTTO', key: 'C01705' },
  { label: 'Extra UE - PATTO RISERVATO DOMINIO', key: 'C01704' },
  { label: 'Extra UE - LOCAZIONE', key: 'C01703' },
  { label: 'Extra UE - MINI VOLTURA', key: 'C01702' },
  { label: 'Extra UE - PROPRIETÀ', key: 'C01701' },
  { label: 'UE - PROPRIETÀ', key: 'C11701' },
  { label: 'UE - PATTO RISERVATO DOMINIO', key: 'C11704' },
  { label: 'UE - MINI VOLTURA', key: 'C11702' },
  { label: 'LOCAZIONE', key: 'C11802' },
  { label: 'USUFRUTTO', key: 'C11804' },
  { label: 'PROPRIETÀ', key: 'C11801' },
  { label: 'PATTO RISERVATO DOMINIO', key: 'C11803' },
  { label: 'ESPORTAZIONE CON FOGLIO DI VIA', key: 'C05313' },
  { label: 'PROPRIETA', key: 'C11501' },
  { label: 'LOCAZIONE', key: 'C11502' },
  { label: 'DUPLICATO UCO', key: 'C18809' },
  { label: 'STAMPA DU - VEICOLO DL98', key: 'C18814' },
  { label: 'STAMPA DU - VEICOLO CON CDC/CDP/CDPD', key: 'C18815' },
  { label: 'DUPLICATO UCO CON CAMBIO INDIRIZZO', key: 'C18819' }
];

export const CLASSE_INQUINAMENTO_PROPS = [
  { label: 'EURO2', key: '1A' },
  { label: 'EURO2', key: '1E' },
  { label: 'EURO2', key: '1I' },
  { label: 'EURO2', key: '1N' },
  { label: 'EURO2', key: '1P' },
  { label: 'EURO2', key: '1Q' },
  { label: 'EURO2', key: '1R' },
  { label: 'EURO2', key: '1T' },
  { label: 'EURO2', key: '1U' },
  { label: 'EURO2', key: '1V' },
  { label: 'EURO2', key: '2C' },
  { label: 'EURO2', key: '2D' },
  { label: 'EURO2', key: '2E' },
  { label: 'EURO2', key: '2I' },
  { label: 'EURO2', key: '2L' },
  { label: 'EURO2', key: '2M' },
  { label: 'EURO2', key: '2Q' },
  { label: 'EURO2', key: '2U' },
  { label: 'EURO2', key: '3A' },
  { label: 'EURO2', key: '3C' },
  { label: 'EURO2', key: '3D' },
  { label: 'EURO2', key: '3E' },
  { label: 'EURO2', key: '3G' },
  { label: 'EURO2', key: '3H' },
  { label: 'EURO2', key: '3I' },
  { label: 'EURO2', key: '3O' },
  { label: 'EURO2', key: '3P' },
  { label: 'EURO2', key: '3Q' },
  { label: 'EURO2', key: '3V' },
  { label: 'EURO2', key: '3Z' },
  { label: 'EURO2', key: '4A' },
  { label: 'EURO2', key: '4E' },
  { label: 'EURO2', key: '4I' },
  { label: 'EURO2', key: '4N' },
  { label: 'EURO2', key: '4P' },
  { label: 'EURO2', key: '4Q' },
  { label: 'EURO2', key: '4R' },
  { label: 'EURO2', key: '4T' },
  { label: 'EURO2', key: '4U' },
  { label: 'EURO2', key: '4V' },
  { label: 'EURO2', key: '5C' },
  { label: 'EURO2', key: '5D' },
  { label: 'EURO2', key: '5E' },
  { label: 'EURO2', key: '5I' },
  { label: 'EURO2', key: '5L' },
  { label: 'EURO2', key: '5M' },
  { label: 'EURO2', key: '5Q' },
  { label: 'EURO2', key: '5U' },
  { label: 'EURO2', key: '6A' },
  { label: 'EURO2', key: '6C' },
  { label: 'EURO2', key: '6D' },
  { label: 'EURO2', key: '6E' },
  { label: 'EURO2', key: '6G' },
  { label: 'EURO2', key: '6H' },
  { label: 'EURO2', key: '6I' },
  { label: 'EURO2', key: '6O' },
  { label: 'EURO2', key: '6P' },
  { label: 'EURO2', key: '6Q' },
  { label: 'EURO2', key: '6U' },
  { label: 'EURO2', key: '6V' },
  { label: 'EURO2', key: '6Z' },
  { label: 'EURO2', key: '7D' },
  { label: 'EURO2', key: '7H' },
  { label: 'EURO2', key: '7M' },
  { label: 'EURO2', key: '7O' },
  { label: 'EURO2', key: '7P' },
  { label: 'EURO2', key: '7Q' },
  { label: 'EURO2', key: '7S' },
  { label: 'EURO2', key: '7T' },
  { label: 'EURO2', key: '7U' },
  { label: 'EURO2', key: '8B' },
  { label: 'EURO2', key: '8C' },
  { label: 'EURO2', key: '8D' },
  { label: 'EURO2', key: '8H' },
  { label: 'EURO2', key: '8I' },
  { label: 'EURO2', key: '8L' },
  { label: 'EURO2', key: '8P' },
  { label: 'EURO2', key: '8T' },
  { label: 'EURO2', key: '8Z' },
  { label: 'EURO2', key: '9B' },
  { label: 'EURO2', key: '9C' },
  { label: 'EURO2', key: '9D' },
  { label: 'EURO2', key: '9F' },
  { label: 'EURO2', key: '9G' },
  { label: 'EURO2', key: '9H' },
  { label: 'EURO2', key: '9N' },
  { label: 'EURO2', key: '9O' },
  { label: 'EURO2', key: '9P' },
  { label: 'EURO2', key: '9T' },
  { label: 'EURO2', key: '9U' },
  { label: 'EURO2', key: '9V' },
  { label: 'EURO0', key: 'A -' },
  { label: 'EURO0', key: 'A' },
  { label: 'EURO0', key: 'A +' },
  { label: 'EURO2', key: 'A0' },
  { label: 'EURO5', key: 'A11' },
  { label: 'EURO5', key: 'A12' },
  { label: 'EURO5', key: 'A13' },
  { label: 'EURO5', key: 'A14' },
  { label: 'EURO6', key: 'A15' },
  { label: 'EURO6', key: 'A16' },
  { label: 'EURO6', key: 'A17' },
  { label: 'EURO6', key: 'A18' },
  { label: 'EURO6', key: 'A19' },
  { label: 'EURO0', key: 'A2-' },
  { label: 'EURO0', key: 'A2' },
  { label: 'EURO0', key: 'A2+' },
  { label: 'EURO6', key: 'A20' },
  { label: 'EURO6', key: 'A21' },
  { label: 'EURO5', key: 'A22' },
  { label: 'EURO5', key: 'A23' },
  { label: 'EURO6', key: 'A24' },
  { label: 'EURO6', key: 'A25' },
  { label: 'EURO6', key: 'A26' },

  { label: 'EURO5', key: 'A27' },
  { label: 'EURO5', key: 'A28' },
  { label: 'EURO6', key: 'A29' },
  { label: 'EURO2', key: 'A3' },
  { label: 'EURO6', key: 'A30' },
  { label: 'EURO6', key: 'A31' },
  { label: 'EURO5', key: 'A32' },
  { label: 'EURO5', key: 'A33' },
  { label: 'EURO6', key: 'A34' },
  { label: 'EURO6', key: 'A35' },
  { label: 'EURO6', key: 'A36' },
  { label: 'EURO5', key: 'A37' },
  { label: 'EURO5', key: 'A38' },
  { label: 'EURO6', key: 'A39' },
  { label: 'EURO6', key: 'A40' },
  { label: 'EURO6', key: 'A41' },
  { label: 'EURO6', key: 'A42' },
  { label: 'EURO6', key: 'A43' },
  { label: 'EURO6', key: 'A44' },
  { label: 'EURO5', key: 'A45' },
  { label: 'EURO5', key: 'A46' },
  { label: 'EURO6', key: 'A47' },
  { label: 'EURO6', key: 'A48' },
  { label: 'EURO6', key: 'A49' },
  { label: 'EURO6', key: 'A50' },
  { label: 'EURO6', key: 'A51' },
  { label: 'EURO6', key: 'A52' },
  { label: 'EURO2', key: 'A53' },
  { label: 'EURO3', key: 'A54' },
  { label: 'EURO3', key: 'A55' },
  { label: 'EURO3', key: 'A56' },
  { label: 'EURO2', key: 'A7' },
  { label: 'EURO0', key: 'AB-' },
  { label: 'EURO0', key: 'AB' },
  { label: 'EURO0', key: 'AB+' },
  { label: 'EURO0', key: 'AC-' },
  { label: 'EURO0', key: 'AC' },
  { label: 'EURO0', key: 'AC+' },
  { label: 'EURO0', key: 'AD-' },
  { label: 'EURO0', key: 'AD' },
  { label: 'EURO0', key: 'AD+' },
  { label: 'EURO0', key: 'AE-' },
  { label: 'EURO0', key: 'AE' },
  { label: 'EURO0', key: 'AE+' },
  { label: 'EURO1', key: 'AF-' },
  { label: 'EURO1', key: 'AF' },
  { label: 'EURO1', key: 'AF+' },
  { label: 'EURO0', key: 'B -' },
  { label: 'EURO0', key: 'B' },
  { label: 'EURO0', key: 'B +' },
  { label: 'EURO2', key: 'B2' },
  { label: 'EURO2', key: 'B3' },
  { label: 'EURO2', key: 'B4' },
  { label: 'EURO2', key: 'B6' },
  { label: 'EURO2', key: 'B7' },
  { label: 'EURO2', key: 'B8' },
  { label: 'EURO0', key: 'BC-' },
  { label: 'EURO0', key: 'BC' },
  { label: 'EURO0', key: 'BC+' },
  { label: 'EURO0', key: 'BD-' },
  { label: 'EURO0', key: 'BD' },
  { label: 'EURO0', key: 'BD+' },
  { label: 'EURO0', key: 'BE-' },
  { label: 'EURO0', key: 'BE' },
  { label: 'EURO0', key: 'BE+' },
  { label: 'EURO1', key: 'BF-' },
  { label: 'EURO1', key: 'BF' },
  { label: 'EURO1', key: 'BF+' },
  { label: 'EURO0', key: 'C -' },
  { label: 'EURO0', key: 'C' },
  { label: 'EURO0', key: 'C +' },
  { label: 'EURO2', key: 'C0' },
  { label: 'EURO2', key: 'C2' },
  { label: 'EURO2', key: 'C3' },
  { label: 'EURO2', key: 'C4' },
  { label: 'EURO2', key: 'C8' },
  { label: 'EURO2', key: 'C9' },
  { label: 'EURO0', key: 'CD-' },
  { label: 'EURO0', key: 'CD' },
  { label: 'EURO0', key: 'CD+' },
  { label: 'EURO0', key: 'CE-' },
  { label: 'EURO0', key: 'CE' },
  { label: 'EURO0', key: 'CE+' },
  { label: 'EURO1', key: 'CF-' },
  { label: 'EURO1', key: 'CF' },
  { label: 'EURO1', key: 'CF+' },
  { label: 'EURO0', key: 'D -' },
  { label: 'EURO0', key: 'D' },
  { label: 'EURO0', key: 'D +' },
  { label: 'EURO2', key: 'D4' },
  { label: 'EURO2', key: 'D8' },
  { label: 'EURO0', key: 'DE-' },
  { label: 'EURO0', key: 'DE' },
  { label: 'EURO0', key: 'DE+' },
  { label: 'EURO1', key: 'DF-' },
  { label: 'EURO1', key: 'DF' },
  { label: 'EURO1', key: 'DF+' },
  { label: 'EURO0', key: 'E -' },
  { label: 'EURO0', key: 'E' },
  { label: 'EURO0', key: 'E +' },
  { label: 'EURO2', key: 'E1' },
  { label: 'EURO2', key: 'E3' },
  { label: 'EURO2', key: 'E4' },
  { label: 'EURO2', key: 'E5' },
  { label: 'EURO2', key: 'E7' },
  { label: 'EURO2', key: 'E8' },
  { label: 'EURO2', key: 'E9' },
  { label: 'EURO1', key: 'EF-' },
  { label: 'EURO1', key: 'EF' },
  { label: 'EURO1', key: 'EF+' },
  { label: 'EURO1', key: 'F -' },
  { label: 'EURO1', key: 'F' },
  { label: 'EURO1', key: 'F +' },
  { label: 'EURO2', key: 'F0' },
  { label: 'EURO2', key: 'F3' },
  { label: 'EURO2', key: 'F4' },
  { label: 'EURO2', key: 'F5' },
  { label: 'EURO2', key: 'F9' },
  { label: 'EURO1', key: 'FL' },
  { label: 'EURO1', key: 'FM' },
  { label: 'EURO1', key: 'G' },
  { label: 'EURO2', key: 'G1' },
  { label: 'EURO2', key: 'G5' },
  { label: 'EURO2', key: 'G9' },
  { label: 'EURO1', key: 'GL' },
  { label: 'EURO1', key: 'H -' },
  { label: 'EURO1', key: 'H' },
  { label: 'EURO1', key: 'H +' },
  { label: 'EURO2', key: 'H0' },
  { label: 'EURO2', key: 'H2' },
  { label: 'EURO2', key: 'H4' },
  { label: 'EURO2', key: 'H5' },
  { label: 'EURO2', key: 'H6' },
  { label: 'EURO2', key: 'H8' },
  { label: 'EURO2', key: 'H9' },
  { label: 'EURO2', key: 'I -' },
  { label: 'EURO2', key: 'I' },
  { label: 'EURO2', key: 'I +' },
  { label: 'EURO2', key: 'I0' },
  { label: 'EURO2', key: 'I4' },
  { label: 'EURO2', key: 'I5' },
  { label: 'EURO2', key: 'I6' },
  { label: 'EURO2', key: 'J0' },
  { label: 'EURO2', key: 'J1' },
  { label: 'EURO2', key: 'J2' },
  { label: 'EURO2', key: 'J3' },
  { label: 'EURO2', key: 'J4' },
  { label: 'EURO2', key: 'J6' },
  { label: 'EURO2', key: 'J7' },
  { label: 'EURO2', key: 'J8' },
  { label: 'EURO2', key: 'JI' },
  { label: 'EURO2', key: 'K0' },
  { label: 'EURO2', key: 'K1' },
  { label: 'EURO2', key: 'K2' },
  { label: 'EURO2', key: 'K3' },
  { label: 'EURO2', key: 'K4' },
  { label: 'EURO2', key: 'K5' },
  { label: 'EURO2', key: 'K6' },
  { label: 'EURO2', key: 'K7' },
  { label: 'EURO2', key: 'K8' },
  { label: 'EURO2', key: 'K9' },
  { label: 'EURO1', key: 'KH' },
  { label: 'EURO0', key: 'KM' },
  { label: 'EURO2', key: 'KO' },
  { label: 'EURO2', key: 'KP' },
  { label: 'EURO0', key: 'L' },
  { label: 'EURO2', key: 'L0' },
  { label: 'EURO2', key: 'L1' },
  { label: 'EURO2', key: 'L2' },
  { label: 'EURO2', key: 'L6' },
  { label: 'EURO1', key: 'LH' },
  { label: 'EURO2', key: 'LI' },
  { label: 'EURO0', key: 'LM' },
  { label: 'EURO0', key: 'LP' },
  { label: 'EURO1', key: 'LX' },
  { label: 'EURO2', key: 'LY' },
  { label: 'EURO0', key: 'M' },
  { label: 'EURO2', key: 'M0' },
  { label: 'EURO2', key: 'M3' },
  { label: 'EURO2', key: 'M5' },
  { label: 'EURO2', key: 'M6' },
  { label: 'EURO2', key: 'M7' },

  { label: 'EURO2', key: 'M9' },
  { label: 'EURO1', key: 'MH' },
  { label: 'EURO2', key: 'MI' },
  { label: 'EURO2', key: 'MY' },
  { label: 'EURO2', key: 'N1' },
  { label: 'EURO2', key: 'N5' },
  { label: 'EURO2', key: 'N6' },
  { label: 'EURO2', key: 'N7' },

  { label: 'EURO2', key: 'O' },
  { label: 'EURO2', key: 'O1' },
  { label: 'EURO2', key: 'O2' },
  { label: 'EURO2', key: 'O3' },
  { label: 'EURO2', key: 'O7' },
  { label: 'EURO0', key: 'P' },
  { label: 'EURO2', key: 'P0' },
  { label: 'EURO2', key: 'P1' },
  { label: 'EURO2', key: 'P4' },
  { label: 'EURO2', key: 'P6' },
  { label: 'EURO2', key: 'P7' },
  { label: 'EURO2', key: 'P8' },
  { label: 'EURO1', key: 'PH' },
  { label: 'EURO2', key: 'PY' },
  { label: 'EURO2', key: 'Q' },
  { label: 'EURO2', key: 'Q1' },
  { label: 'EURO2', key: 'Q6' },
  { label: 'EURO2', key: 'Q7' },
  { label: 'EURO2', key: 'Q8' },
  { label: 'EURO4', key: 'QA' },
  { label: 'EURO5', key: 'QB' },
  { label: 'EURO5', key: 'QC' },
  { label: 'EURO4', key: 'QD' },
  { label: 'EURO5', key: 'QE' },
  { label: 'EURO5', key: 'QF' },
  { label: 'EURO4', key: 'QG' },
  { label: 'EURO5', key: 'QH' },
  { label: 'EURO5', key: 'QI' },
  { label: 'EURO3', key: 'QJ' },
  { label: 'EURO4', key: 'QK' },
  { label: 'EURO4', key: 'QL' },
  { label: 'EURO4', key: 'QM' },
  { label: 'EURO5', key: 'QN' },
  { label: 'EURO5', key: 'QO' },
  { label: 'EURO4', key: 'QP' },
  { label: 'EURO5', key: 'QQ' },
  { label: 'EURO5', key: 'QR' },
  { label: 'EURO2', key: 'QS' },
  { label: 'EURO3', key: 'QT' },
  { label: 'EURO2', key: 'QU' },
  { label: 'EURO3', key: 'QV' },
  { label: 'EURO5', key: 'QW' },
  { label: 'EURO5', key: 'QX' },
  { label: 'EURO5', key: 'QY' },
  { label: 'EURO3', key: 'QZ' },
  { label: 'EURO2', key: 'R2' },
  { label: 'EURO2', key: 'R3' },
  { label: 'EURO2', key: 'R4' },
  { label: 'EURO2', key: 'R8' },
  { label: 'EURO5', key: 'RA' },
  { label: 'EURO6', key: 'RB' },
  { label: 'EURO6', key: 'RC' },
  { label: 'EURO6', key: 'RD' },
  { label: 'EURO6', key: 'RE' },
  { label: 'EURO4', key: 'RF' },
  { label: 'EURO5', key: 'RG' },
  { label: 'EURO1', key: 'RH' },
  { label: 'EURO2', key: 'RI' },
  { label: 'EURO5', key: 'RJ' },
  { label: 'EURO4', key: 'RK' },
  { label: 'EURO5', key: 'RL' },
  { label: 'EURO5', key: 'RM' },
  { label: 'EURO3', key: 'RN' },
  { label: 'EURO3', key: 'RO' },
  { label: 'EURO3', key: 'RP' },
  { label: 'EURO3', key: 'RQ' },
  { label: 'EURO3', key: 'RR' },
  { label: 'EURO3', key: 'RS' },
  { label: 'EURO3', key: 'RT' },
  { label: 'EURO2', key: 'RU' },
  { label: 'EURO3', key: 'RV' },
  { label: 'EURO3', key: 'RZ' },
  { label: 'EURO2', key: 'S2' },
  { label: 'EURO2', key: 'S5' },
  { label: 'EURO2', key: 'S7' },
  { label: 'EURO2', key: 'S8' },
  { label: 'EURO2', key: 'S9' },
  { label: 'EURO2', key: 'SA' },
  { label: 'EURO2', key: 'SB' },
  { label: 'EURO2', key: 'SC' },
  { label: 'EURO2', key: 'SD' },
  { label: 'EURO2', key: 'SE' },
  { label: 'EURO2', key: 'SF' },
  { label: 'EURO2', key: 'SG' },
  { label: 'EURO2', key: 'SH' },
  { label: 'EURO2', key: 'SI' },
  { label: 'EURO2', key: 'SJ' },
  { label: 'EURO2', key: 'SK' },
  { label: 'EURO2', key: 'SL' },
  { label: 'EURO2', key: 'SM' },
  { label: 'EURO2', key: 'SN' },
  { label: 'EURO2', key: 'SO' },
  { label: 'EURO2', key: 'SP' },
  { label: 'EURO2', key: 'SQ' },
  { label: 'EURO2', key: 'SR' },
  { label: 'EURO2', key: 'ST' },
  { label: 'EURO2', key: 'SU' },
  { label: 'EURO2', key: 'SV' },
  { label: 'EURO2', key: 'SX' },
  { label: 'EURO2', key: 'SY' },
  { label: 'EURO2', key: 'SZ' },
  { label: 'EURO2', key: 'T1' },
  { label: 'EURO2', key: 'T2' },
  { label: 'EURO2', key: 'T3' },
  { label: 'EURO2', key: 'T7' },
  { label: 'EURO2', key: 'T8' },
  { label: 'EURO2', key: 'T9' },
  { label: 'EURO2', key: 'TA' },
  { label: 'EURO4', key: 'TB' },
  { label: 'EURO2', key: 'TC' },
  { label: 'EURO2', key: 'TD' },
  { label: 'EURO2', key: 'TE' },
  { label: 'EURO2', key: 'TG' },
  { label: 'EURO2', key: 'TH' },
  { label: 'EURO2', key: 'TI' },
  { label: 'EURO2', key: 'TL' },
  { label: 'EURO2', key: 'TP' },
  { label: 'EURO2', key: 'TQ' },
  { label: 'EURO2', key: 'TR' },
  { label: 'EURO2', key: 'TV' },
  { label: 'EURO2', key: 'TZ' },
  { label: 'EURO2', key: 'U3' },
  { label: 'EURO2', key: 'U4' },
  { label: 'EURO2', key: 'U5' },
  { label: 'EURO2', key: 'U9' },
  { label: 'EURO2', key: 'UA' },
  { label: 'EURO2', key: 'UE' },
  { label: 'EURO2', key: 'UI' },
  { label: 'EURO2', key: 'UN' },
  { label: 'EURO2', key: 'UP' },
  { label: 'EURO2', key: 'UQ' },
  { label: 'EURO2', key: 'UR' },
  { label: 'EURO2', key: 'UT' },
  { label: 'EURO2', key: 'UU' },
  { label: 'EURO2', key: 'UV' },
  { label: 'EURO2', key: 'V0' },
  { label: 'EURO2', key: 'V3' },
  { label: 'EURO2', key: 'V6' },
  { label: 'EURO2', key: 'V8' },
  { label: 'EURO2', key: 'V9' },
  { label: 'EURO4', key: 'VB' },
  { label: 'EURO2', key: 'VC' },
  { label: 'EURO2', key: 'VD' },
  { label: 'EURO2', key: 'VE' },
  { label: 'EURO2', key: 'VI' },
  { label: 'EURO2', key: 'VL' },
  { label: 'EURO2', key: 'VM' },
  { label: 'EURO2', key: 'VQ' },
  { label: 'EURO2', key: 'VU' },
  { label: 'EURO0', key: 'W ' },
  { label: 'EURO0', key: 'W' },
  { label: 'EURO0', key: 'W ' },
  { label: 'EURO2', key: 'W0' },
  { label: 'EURO2', key: 'W1' },
  { label: 'EURO3', key: 'W2' },
  { label: 'EURO3', key: 'W3' },
  { label: 'EURO2', key: 'W4' },
  { label: 'EURO2', key: 'W5' },
  { label: 'EURO2', key: 'W6' },
  { label: 'EURO3', key: 'W7' },
  { label: 'EURO4', key: 'W8' },
  { label: 'EURO4', key: 'W9' },
  { label: 'EURO3', key: 'WA' },
  { label: 'EURO4', key: 'WB' },
  { label: 'EURO2', key: 'WC' },
  { label: 'EURO3', key: 'WD' },
  { label: 'EURO4', key: 'WE' },
  { label: 'EURO3', key: 'WF' },
  { label: 'EURO4', key: 'WG' },
  { label: 'EURO5', key: 'WH' },
  { label: 'EURO5', key: 'WI' },
  { label: 'EURO4', key: 'WJ' },
  { label: 'EURO3', key: 'WK' },
  { label: '', key: 'WL' },
  { label: '', key: 'WM' },
  { label: '', key: 'WN' },
  { label: '', key: 'WO' },
  { label: 'EURO3', key: 'WP' },
  { label: 'EURO4', key: 'WQ' },
  { label: 'EURO3', key: 'WR' },
  { label: 'EURO4', key: 'WS' },
  { label: 'EURO5', key: 'WT' },
  { label: 'EURO5', key: 'WU' },
  { label: 'EURO2', key: 'WV' },
  { label: 'EURO4', key: 'WW' },
  { label: 'EURO2', key: 'WX' },
  { label: 'EURO3', key: 'WY' },
  { label: 'EURO3', key: 'WZ' },
  { label: 'EURO1', key: 'X' },
  { label: 'EURO2', key: 'X0' },
  { label: 'EURO2', key: 'X1' },
  { label: 'EURO2', key: 'X2' },
  { label: '', key: 'X3' },
  { label: 'EURO2', key: 'X4' },
  { label: 'EURO2', key: 'X5' },
  { label: 'EURO2', key: 'X6' },
  { label: 'EURO2', key: 'X7' },
  { label: 'EURO2', key: 'X8' },
  { label: 'EURO2', key: 'X9' },

  { label: 'EURO2', key: 'XA' },
  { label: 'EURO2', key: 'XC' },
  { label: 'EURO2', key: 'XD' },
  { label: 'EURO2', key: 'XE' },
  { label: 'EURO2', key: 'XG' },
  { label: 'EURO2', key: 'XH' },
  { label: 'EURO2', key: 'XI' },
  { label: 'EURO2', key: 'XL' },
  { label: 'EURO2', key: 'XM' },
  { label: 'EURO2', key: 'XN' },
  { label: 'EURO2', key: 'XO' },
  { label: 'EURO2', key: 'XP' },
  { label: 'EURO2', key: 'XQ' },
  { label: 'EURO2', key: 'XR' },
  { label: 'EURO2', key: 'XS' },
  { label: 'EURO2', key: 'XT' },
  { label: 'EURO2', key: 'XV' },
  { label: 'EURO2', key: 'XY' },
  { label: 'EURO2', key: 'XZ' },
  { label: 'EURO2', key: 'Y' },
  { label: 'EURO2', key: 'Y0' },
  { label: 'EURO2', key: 'Y4' },
  { label: 'EURO2', key: 'Y7' },
  { label: 'EURO2', key: 'Y9' },
  { label: 'EURO2', key: 'YA' },
  { label: 'EURO2', key: 'YC' },
  { label: 'EURO2', key: 'YD' },
  { label: 'EURO2', key: 'YE' },
  { label: 'EURO2', key: 'YF' },
  { label: 'EURO2', key: 'YG' },
  { label: 'EURO2', key: 'YH' },
  { label: 'EURO2', key: 'YI' },
  { label: 'EURO2', key: 'YL' },
  { label: 'EURO2', key: 'YM' },
  { label: 'EURO2', key: 'YN' },
  { label: 'EURO2', key: 'YO' },
  { label: 'EURO2', key: 'YP' },
  { label: 'EURO1', key: 'YQ' },
  { label: 'EURO0', key: 'YR' },
  { label: 'EURO1', key: 'YS' },
  { label: 'EURO3', key: 'YT' },
  { label: 'EURO2', key: 'YU' },
  { label: 'EURO3', key: 'YV' },
  { label: 'EURO2', key: 'YZ' },
  { label: 'EURO2', key: 'Z0' },
  { label: 'EURO4', key: 'Z1' },
  { label: 'EURO2', key: 'Z2' },
  { label: 'EURO2', key: 'Z3' },
  { label: 'EURO2', key: 'Z4' },
  { label: 'EURO4', key: 'Z5' },
  { label: 'EURO4', key: 'Z6' },
  { label: 'EURO4', key: 'Z7' },
  { label: 'EURO2', key: 'Z8' },
  { label: 'EURO2', key: 'Z9' },
  { label: 'EURO2', key: 'ZA' },
  { label: 'EURO2', key: 'ZC' },
  { label: 'EURO2', key: 'ZD' },
  { label: 'EURO2', key: 'ZE' },
  { label: 'EURO2', key: 'ZG' },
  { label: 'EURO2', key: 'ZH' },
  { label: 'EURO2', key: 'ZI' },
  { label: 'EURO4', key: 'ZL' },
  { label: 'EURO5', key: 'ZM' },
  { label: 'EURO5', key: 'ZN' },
  { label: 'EURO2', key: 'ZO' },
  { label: 'EURO2', key: 'ZP' },
  { label: 'EURO2', key: 'ZQ' },
  { label: 'EURO4', key: 'ZR' },
  { label: 'EURO5', key: 'ZS' },
  { label: 'EURO5', key: 'ZT' },
  { label: 'EURO2', key: 'ZU' },
  { label: 'EURO2', key: 'ZV' },
  { label: 'EURO2', key: 'ZW' },
  { label: 'EURO3', key: 'ZX' },
  { label: 'EURO0', key: 'ZZ' },
  { label: 'EURO6', key: 'A57' },
  { label: 'EURO6', key: 'A58' },
  { label: 'EURO6', key: 'A59' },
  { label: 'EURO4', key: 'A60' },
  { label: 'EURO5', key: 'A61' },
  { label: 'EURO5', key: 'A62' },
  { label: 'EURO6', key: 'A63' },
  { label: 'EURO6', key: 'A64' },
  { label: 'EURO6', key: 'A65' },
  { label: 'EURO4', key: 'A66' },
  { label: 'EURO5', key: 'A67' },
  { label: 'EURO5', key: 'A68' },
  { label: 'EURO5', key: 'A69' },
  { label: '', key: 'A84' },
  { label: '', key: 'A85' },
  { label: 'EURO6', key: 'A86' },
  { label: 'EURO6', key: 'A87' },
  { label: 'EURO6', key: 'A88' },
  { label: 'EURO6', key: 'A89' },
  { label: 'EURO6', key: 'A90' },
  { label: 'EURO6', key: 'A91' },
  { label: 'EURO6', key: 'A92' },
  { label: 'EURO6', key: 'A93' },
  { label: 'EURO6', key: 'A94' },
  { label: 'EURO6', key: 'A95' },
  { label: 'EURO6', key: 'A96' },
  { label: 'EURO6', key: 'A97' },
  { label: 'EURO6', key: 'A98' },
  { label: 'EURO6', key: 'A99' },
  { label: 'EURO6', key: 'B00' },
  { label: 'EURO6', key: 'B01' },
  { label: 'EURO6', key: 'B02' },
  { label: 'EURO6', key: 'B03' },
  { label: 'EURO6', key: 'B04' },
  { label: 'EURO6', key: 'B05' },
  { label: 'EURO6', key: 'B06' },
  { label: 'EURO6', key: 'B07' },
  { label: 'EURO6', key: 'B08' },
  { label: 'EURO6', key: 'B09' },
  { label: 'EURO6', key: 'B10' },
  { label: 'EURO6', key: 'B11' },
  { label: 'EURO5', key: 'B12' },
  { label: 'EURO5', key: 'B13' },
  { label: 'EURO5', key: 'B14' },
  { label: 'EURO5', key: 'B15' },
  { label: 'EURO6', key: 'B16' },
  { label: 'EURO5', key: 'B17' },
  { label: 'EURO5', key: 'B18' },
  { label: 'EURO5', key: 'B19' },
  { label: 'EURO5', key: 'B20' },
  { label: 'EURO6', key: 'B21' },
  { label: 'EURO6', key: 'B22' },
  { label: 'EURO6', key: 'B23' },
  { label: 'EURO6', key: 'B24' },
  { label: 'EURO6', key: 'B25' },
  { label: 'EURO6', key: 'B26' },
  { label: 'EURO6', key: 'B27' },
  { label: 'EURO6', key: 'B28' },
  { label: 'EURO6', key: 'B29' },
  { label: 'EURO6', key: 'B30' },
  { label: 'EURO6', key: 'B31' },
  { label: 'EURO6', key: 'B33' },
  { label: 'EURO6', key: 'B34' },
  { label: 'EURO6', key: 'B35' },
  { label: 'EURO6', key: 'B36' },
  { label: 'EURO6', key: 'B37' },
  { label: 'EURO6', key: 'B38' },
  { label: 'EURO6', key: 'B39' },
  { label: 'EURO6', key: 'B40' },
  { label: 'EURO6', key: 'B41' },
  { label: 'EURO6', key: 'B42' },
  { label: 'EURO6', key: 'B43' },
  { label: 'EURO6', key: 'B44' },
  { label: 'EURO6', key: 'B45' },
  { label: 'EURO6', key: 'B46' },
  { label: 'EURO6', key: 'B47' },
  { label: 'EURO6', key: 'B48' },
  { label: 'EURO6', key: 'B49' },
  { label: 'EURO6', key: 'B50' },
  { label: 'EURO6', key: 'B51' },
  { label: 'EURO6', key: 'B52' },
  { label: 'EURO6', key: 'B53' },
  { label: 'EURO6', key: 'B54' },
  { label: 'EURO6', key: 'B55' },
  { label: 'EURO6', key: 'B56' },
  { label: 'EURO6', key: 'B57' },
  { label: 'EURO6', key: 'B58' },
  { label: 'EURO6', key: 'B59' },
  { label: 'EURO6', key: 'B60' },
  { label: 'EURO6', key: 'B61' },
  { label: 'EURO6', key: 'B62' },
  { label: 'EURO6', key: 'B63' },
  { label: 'EURO6', key: 'B64' },
  { label: 'EURO6', key: 'B67' },
  { label: 'EURO6C', key: 'B68' },
  { label: 'EURO6D', key: 'B69' },
  { label: 'EURO6', key: 'B70' },
  { label: 'EURO6', key: 'B71' },
  { label: 'EURO6', key: 'B72' },
  { label: 'EURO6', key: 'B73' },
  { label: 'EURO6A', key: 'B74' },
  { label: 'EURO6', key: 'B75' },
  { label: 'EURO6', key: 'B76' },
  { label: 'EURO6', key: 'B77' },
  { label: 'EURO6A', key: 'B78' },
  { label: 'EURO6', key: 'B79' },
  { label: 'EURO6C', key: 'B80' },
  { label: 'EURO6D', key: 'B81' },
  { label: 'EURO6', key: 'B82' },
  { label: 'EURO6', key: 'B83' },
  { label: 'EURO6', key: 'B85' },
  { label: 'EURO6', key: 'B86' },
  { label: 'EURO6A', key: 'B87' },
  { label: 'EURO6D', key: 'B88' },
  { label: 'EURO6', key: 'B91' },
  { label: 'EURO6', key: 'B92' },
  { label: 'EURO6', key: 'B93' },
  { label: 'EURO6', key: 'B94' },
  { label: 'EURO6', key: 'B97' },
  { label: 'EURO6', key: 'B98' },
  { label: 'EURO6', key: 'C00' },
  { label: 'EURO6', key: 'C01' },
  { label: 'EURO6', key: 'C02' },
  { label: 'EURO6', key: 'C03' },
  { label: 'EURO6', key: 'C04' },
  { label: 'EURO6', key: 'C05' },
  { label: 'EURO6', key: 'C06' },
  { label: 'EURO6', key: 'C07' },
  { label: 'EURO6', key: 'C08' },
  { label: 'EURO6', key: 'C10' },
  { label: 'EURO6', key: 'C11' },
  { label: 'EURO6', key: 'C12' },
  { label: 'EURO6', key: 'C13' },
  { label: 'EURO6', key: 'C14' },
  { label: 'EURO6', key: 'C15' },
  { label: 'EURO6', key: 'C16' },
  { label: 'EURO6', key: 'C17' },
  { label: 'EURO6', key: 'C18' },
  { label: 'EURO6', key: 'C19' },
  { label: 'EURO6D', key: 'C22' },
  { label: 'EURO6', key: 'C23' },
  { label: 'EURO6D', key: 'C24' },
  { label: 'EURO6', key: 'C25' },
  { label: 'EURO6E', key: 'C27' },
  { label: 'EURO6', key: 'C28' },
  { label: 'EURO6', key: 'C29' },
  { label: 'EURO6E', key: 'C30' },
  { label: 'EURO6D', key: 'C31' },
  { label: 'EURO6', key: 'RB' },
  { label: 'EURO6', key: 'RC' },
  { label: 'EURO6', key: 'RD' },
  { label: 'EURO6', key: 'RE' }
];

export const COD_ALIMENTAZIONE_PROPS = [
  { label: 'Benzina', key: 'B' },
  { label: 'Benzina/Olio', key: 'B-O' },
  { label: 'Benzina/Wank', key: 'B-W' },
  { label: 'Elettrica', key: 'ELE' },
  { label: 'Gasolio', key: 'G' },
  { label: 'GPL', key: 'GP' },
  { label: 'Benzina/GPL', key: 'GPL' },
  { label: 'Benzina/Metano', key: 'M' },
  { label: 'Metano', key: 'ME' },
  { label: 'Miscela', key: 'MSC' },
  { label: 'Petrolio', key: 'P' },
  { label: 'Ibrido Benzina/Elettrica', key: 'B-E' },
  { label: 'Ibrido Gasolio/Elettrica', key: 'G-E' },
  { label: 'Benzina/ETA', key: 'BET' },
  { label: 'FAP - Filtro anti Particolato', key: 'F' },
  { label: 'Gasolio - GPL', key: 'G-G' },
  { label: 'Gasolio - Metano', key: 'G-M' },
  { label: 'Gas Naturale Liquefatto', key: 'GNL' },
  { label: 'Ibrido Gasolio - GNL', key: 'GML' },
  { label: 'Idrogeno', key: 'H' }
];

export const COD_LEGGE_PROPS = [
  { label: 'Non usufruisce di benefici di legge', key: '0' },
  { label: "Usufruisce di benefici di legge (beneficia della classe di merito di un precedente contratto, ai sensi dell'articolo 134, comma 4-bis, del Codice delle assicurazioni)", key: '1' },
  {
    label:
      "Usufruisce di benefici di legge per un ulteriore veicolo di diversa tipologia (beneficia della classe di merito di altro contratto su diversa tipologia di veicolo, ai sensi dell'articolo 134, comma 4-bis, del Codice delle assicurazioni)",
    key: '2'
  },
  {
    label:
      "Usufruisce di benefici di legge in caso di rinnovo (beneficia della classe di merito di altro contratto su veicolo della stessa tipologia, ai sensi dell'articolo 134, comma 4-bis, del Codice delle assicurazioni)",
    key: '3'
  },
  {
    label:
      "Usufruisce di benefici di legge in caso di rinnovo (beneficia della classe di merito di altro contratto su veicolo di diversa tipologia, ai sensi dell'articolo 134, comma 4-bis, del Codice delle assicurazioni)",
    key: '4'
  }
];

export const CODICE_CARROZZERIA_PROPS = [
  { key: '4F', label: 'FURGONE' },
  { key: '4K', label: 'CASSONE' },
  { key: '4P', label: 'PIANALE' },
  { key: '4R', label: 'CASSONE RIBALTABILE' },
  { key: '4T', label: 'CABINA CHIUSA CON TELAIO' },
  { key: 'A0', label: 'PER USO PRIVATO' },
  { key: 'A1', label: 'PER NOLEGGIO' },
  { key: 'A2', label: 'TIPO URBANO' },
  { key: 'A3', label: 'TIPO INTERURBANO' },
  { key: 'A4', label: 'GRAN TURISMO O INTERNAZIONALE' },
  { key: 'A5', label: 'SUBURBANA' },
  { key: 'A6', label: 'AUTOSNODATO TIPO URBANO' },
  { key: 'A7', label: 'AUTOSNODATO TIPO INTERURBANO' },
  { key: 'A8', label: 'AUTOSNODATO TIPO SUBURBANO' },
  { key: 'A9', label: 'AUTOSNODATO AD USO PRIVATO' },
  { key: 'AA', label: 'BERLINA' },
  { key: 'AB', label: 'DUE VOLUMI' },
  { key: 'AC', label: 'FAMILIARE' },
  { key: 'AD', label: "COUPE'" },
  { key: 'AE', label: 'DECAPPOTTABILE' },
  { key: 'AF', label: 'VEICOLO MULTIUSO' },
  { key: 'AG', label: 'FURGONE' },
  { key: 'AM', label: 'MINIBUS' },
  { key: 'AR', label: 'MINISCUOLABUS' },
  { key: 'AS', label: 'SCUOLABUS' },
  { key: 'AT', label: 'AUTOSNODATO DA NOLEGGIARE CON CONDUCENTE' },
  { key: 'B0', label: 'CHIUSA' },
  { key: 'B1', label: 'APERTA' },
  { key: 'B2', label: 'CHIUSA CON TETTO APRIBILE' },
  { key: 'B3', label: 'CHIUSA TIPO GIARDINETTA' },
  { key: 'B4', label: 'CHIUSA TIPO GIARDINETTA CON TETTO APRIBILE' },
  { key: 'B5', label: 'CHIUSA TRASFORMABILE' },
  { key: 'B6', label: 'CHIUSA 3 PORTE' },
  { key: 'B7', label: 'CHIUSA 5 PORTE' },
  { key: 'B8', label: 'CHIUSA STATION WAGON 2 PORTE' },
  { key: 'B9', label: 'CHIUSA STATION WAGON 4 PORTE' },
  { key: 'BA', label: 'AUTOCARRO' },
  { key: 'BB', label: 'FURGONE (N1-N2-N3)' },
  { key: 'BC', label: 'VEICOLO TRATTORE PER SEMIRIMORCHI' },
  { key: 'BD', label: 'VEICOLO TRATTORE PER RIMORCHI (TRATTORE STRADALE)' },
  { key: 'BE', label: 'FURGONE CON VANO DI CARICO APERTO' },
  { key: 'BG', label: 'CHIUSA 5 PORTE' },
  { key: 'BH', label: 'CHIUSA 2 PORTE' },
  { key: 'BL', label: 'CHIUSA 4 PORTE' },
  { key: 'BM', label: 'CHIUSA 2 PORTE' },
  { key: 'BN', label: 'CHIUSA 4 PORTE' },
  { key: 'BP', label: 'CHIUSA TRASFORMABILE 2 PORTE' },
  { key: 'BR', label: 'CHIUSA TRASFORMABILE 4 PORTE' },
  { key: 'BS', label: 'BLINDATA' },
  { key: 'C0', label: 'BOTTE KILOLITRICA PER TRASPORTO OLII MINERALI E CARBURANTI' },
  { key: 'C1', label: 'CISTERNA PER TRASPORTO OLII MINERALI E CARBURANTI' },
  { key: 'C2', label: 'CISTERNA PER TRASPORTO MERCI PERICOLOSE INFIAMMABILI NON DERIVATE' },
  { key: 'DA', label: 'PETROLIO' },
  { key: 'C3', label: 'CISTERNA PER TRASPORTO MERCI PERICOLOSE DI ORIGINE CHIMICA' },
  { key: 'C4', label: 'CISTERNA PER TRASPORTO DI MERCI NON PERICOLOSE NON COMMESTIBILI' },
  { key: 'C5', label: 'CISTERNA PER TRASPORTO DI MERCI COMMESTIBILI' },
  { key: 'C6', label: 'CISTERNA PER TRASPORTO DI LATTE ALIMENTARE' },
  { key: 'C7', label: 'CISTERNA PER TRASPORTO DI LATTE PER USO INDUSTRIALE' },
  { key: 'C8', label: 'BETONIERA PER TRASPORTO CALCESTRUZZO DI CEMENTO' },
  { key: 'C9', label: 'CISTERNE VERTICALI PER TRASPORTO PRODOTTI GRANULATI E PULVERULENTI' },
  { key: 'PU', label: 'VERULENTI' },
  { key: 'CA', label: 'VEICOLO AD UN PIANO' },
  { key: 'CB', label: 'VEICOLO A DUE PIANI' },
  { key: 'CC', label: 'AUTOSNODATO A UN PIANO' },
  { key: 'CD', label: 'AUTOARTICOLATO A DUE PIANI' },
  { key: 'CE', label: 'VEICOLO AD UN PIANO E PIANALE RIBASSATO' },
  { key: 'CF', label: 'VEICOLO A DUE PIANI E PIANALE RIBASSATO' },
  { key: 'CG', label: 'AUTOSNODATO AD UN PIANO E PIANALE RIBASSATO' },
  { key: 'CH', label: 'AUTOSNODATO A DUE PIANI E PIANALE RIBASSATO' },
  { key: 'CI', label: 'VEICOLO A CIELO APERTO AD UN PIANO' },
  { key: 'CJ', label: 'VEICOLO A CIELO APERTO A DUE PIANI' },
  { key: 'CK', label: 'AUTOSNODATO A UN PIANO DI CLASSE II' },
  { key: 'CL', label: 'AUTOSNODATO A DUE PIANI DI CLASSE II' },
  { key: 'CM', label: 'A UN PIANO E PIANALE RIBASSATO DI CLASSE II' },
  { key: 'CN', label: 'A DUE PIANI E PIANALE RIBASSATO DI CLASSE II' },
  { key: 'CO', label: 'AUTOSNODATO A UN PIANO E PIANALE RIBASSATO DI CLASSE II' },
  { key: 'CP', label: 'AUTOSNODATO A DUE PIANI E PIANALE RIBASSATO DI CLASSE II' },
  { key: 'CQ', label: 'AUTOBUS A UN PIANO DI CLASSE III' },
  { key: 'CR', label: 'AUTOBUS A DUE PIANI DI CLASSE III' },
  { key: 'CS', label: 'AUTOSNODATO A UN PIANO DI CLASSE III' },
  { key: 'CT', label: 'AUTOSNODATO A DUE PIANI DI CLASSE III' },
  { key: 'CU', label: 'AUTOBUS A UN PIANO DI CLASSE A' },
  { key: 'CV', label: 'AUTOBUS A UN PIANO E PIANALE RIBASSATO DI CLASSE A' },
  { key: 'CW', label: 'AUTOBUS A UN PIANO DI CLASSE B' },
  { key: 'DA', label: 'SEMIRIMORCHIO' },
  { key: 'DB', label: 'RIMORCHIO A TIMONE' },
  { key: 'DC', label: 'RIMORCHIO AD ASSE CENTRALE' },
  { key: 'EW', label: 'VEDERE ANNOTAZIONI VEICOLO ECCEZIONALE' },
  { key: 'EY', label: 'VEDERE ANNOTAZIONI VEICOLO ECCEZIONALE' },
  { key: 'EZ', label: 'VEDERE ANNOTAZIONI VEICOLO ECCEZIONALE' },
  { key: 'F0', label: 'FURGONE' },
  { key: 'F1', label: 'FURGONE RIBALTABILE' },
  { key: 'F2', label: 'FURGONE CON SPONDA POSTERIORE CARICATRICE' },
  { key: 'F3', label: 'FURGONE ISOTERMICO CON GRUPPO FRIGORIFERO' },
  { key: 'F4', label: 'FURGONE ISOTERMICO' },
  { key: 'F5', label: 'FURGONE CON GRUPPO AUSILIARIO' },
  { key: 'F6', label: 'FURGONE COIBENTATO' },
  { key: 'F7', label: 'FURGONE ATTREZZATO PER TRASPORTO ANIMALI VIVI' },
  { key: 'F8', label: 'FURGONE ATTREZZATO PER TRASPORTO CARNI MACELLATE APPESE' },
  { key: 'F9', label: 'FURGONE ATTREZZATO PER TRASPORTO CONTENITORI DI LATTE' },
  { key: 'FA', label: 'FURGONE CON COPERTURA IN TELA' },
  { key: 'FB', label: 'FURGONE PER TRASPORTO SPECIFICO DI ANIMALI VIVI' },
  { key: 'FC', label: 'FURGONE CON AVANCORPO SULLA CABINA' },
  { key: 'FD', label: 'FURGONE ATTREZZATO PER TRASPORTO MOBILI E MASSERIZIE CON AVANCORPO SU CABINA' },
  { key: 'FE', label: 'FURGONE INTERCAMBIABILE CON ALTRI AVENTI LE STESSE CARATTERISTICHE' },
  { key: 'FF', label: 'FURGONE FINESTRATO CON UNA PORTA LATERALE' },
  { key: 'FG', label: 'FURGONE PER TRASPORTO SPECIFICO DI' },
  { key: 'FH', label: 'FURGONE ATTREZZATO PER TRASPORTO CARNI MACELLATE IN CESTE' },
  { key: 'FI', label: 'FURGONE CON CENTINE E TELONE AD ALTEZZA VARIABILE' },
  { key: 'FJ', label: 'FURGONE ATTREZZATO USO NEGOZIO CON PARETE LATO DESTRO RIBALTABILE' },
  { key: 'FK', label: 'FURGONE' },
  { key: 'FL', label: 'FURGONE RIALZATO ATTREZZATO PER TRASPORTO CARNI MACELLATE IN CESTE' },
  { key: 'FM', label: 'FURGONE ATTREZZATO PER TRASPORTO MOBILI E MASSERIZIE' },
  { key: 'FN', label: 'FURGONE DI COSTRUZIONE NAZIONALE FURGONE CON PIANO DI CARICO ESTESO' },
  { key: 'FP', label: 'FURGONE CON PIANO DI CARICO ESTESO A TUTTO IL TETTO' },
  { key: 'FR', label: 'FURGONE CON PIANO DI CARICO LIMITATO ALLA SOLA CABINA' },
  { key: 'FS', label: 'FURGONE ATTREZZATO PER TRASPORTO RIFIUTI SOLIDI' },
  { key: 'FT', label: "FURGONE ATTREZZATO CON RULLI PER TRASPORTO PALLETS D'AEREO" },
  { key: 'FU', label: 'FURGONE ATTREZZATO USO NEGOZIO CON PARETE LATO SINISTRO RIBALTABILE' },
  { key: 'FV', label: 'FURGONE A GIORNO PER TRASPORTO BEVANDE IN BOTTIGLIE' },
  { key: 'FW', label: 'FURGONE ATTREZZATO USO CAMPEGGIO' },
  { key: 'FX', label: 'FURGONE FINESTRATO ATTREZZATO USO CAMPEGGIO' },
  { key: 'FY', label: 'FURGONE VETRINATO USO ESPOSIZIONE' },
  { key: 'FZ', label: 'FURGONE VETRINATO CON APERTURA LATERALE USO ESPOSIZIONE' },
  { key: 'G0', label: 'FURGONE CON DUE PORTE LATERALI' },
  { key: 'G1', label: 'FURGONE CON UNA PORTA LATERALE' },
  { key: 'G2', label: 'FURGONE VETRINATO CON DUE PORTE LATERALI' },
  { key: 'G3', label: 'FURGONE VETRINATO CON UNA PORTA LATERALE' },
  { key: 'G4', label: 'FURGONE COIBENTATO CON DUE PORTE LATERALI' },
  { key: 'G5', label: 'FURGONE COIBENTATO CON UNA PORTA LATERALE' },
  { key: 'G6', label: 'FURGONE FINESTRATO' },
  { key: 'G7', label: 'FURGONE LABORATORIO MOBILE' },
  { key: 'G8', label: 'FURGONE FINESTRATO' },
  { key: 'G9', label: 'TRASFORMABILE' },
  { key: 'GA', label: 'FURGONE RIALZATO' },
  { key: 'GB', label: 'FURGONE RIBALTABILE RIALZATO' },
  { key: 'GC', label: 'FURGONE VETRINATO RIALZATO USO ESPOSIZIONE' },
  { key: 'GD', label: 'FURGONE RIALZATO CON SPONDA POSTERIORE CARICATRICE' },
  { key: 'GE', label: 'FURGONE ISOTERMICO RIALZATO CON GRUPPO FRIGORIFERO' },
  { key: 'GF', label: 'FURGONE ISOTERMICO RIALZATO' },
  { key: 'GG', label: 'FURGONE RIALZATO CON GRUPPO AUSILIARIO' },
  { key: 'GH', label: 'FURGONE COIBENTATO RIALZATO' },
  { key: 'GI', label: 'FURGONE VETRINATO' },
  { key: 'GJ', label: 'FURGONE RIALZATO FINESTRATO CON UNA PORTA LATERALE' },
  { key: 'GK', label: 'FURGONE VETRINATO' },
  { key: 'GL', label: 'FURGONE RIALZATO ATTREZZATO PER TRASPORTO ANIMALI VIVI' },
  { key: 'GM', label: 'FURGONE RIALZATO ATTREZZATO PER CARNI MACELLATE APPESE' },
  { key: 'GN', label: 'FURGONE RIALZATO ATTREZZATO PER TRASPORTO CONTENITORI DI LATTE' },
  { key: 'GP', label: 'FURGONE RIALZATO CON DUE PORTE LATERALI' },
  { key: 'GQ', label: 'FURGONE FINESTRATO CON UNA PORTA LATERALE' },
  { key: 'GR', label: 'FURGONE RIALZATO CON UNA PORTA LATERALE' },
  { key: 'GS', label: 'FURGONE RIALZATO VETRINATO CON DUE PORTE LATERALI' },
  { key: 'GT', label: 'FURGONE RIALZATO VETRINATO CON UNA PORTA LATERALE' },
  { key: 'GU', label: 'FURGONE COIBENTATO RIALZATO CON DUE PORTE LATERALI' },
  { key: 'GV', label: 'FURGONE COIBENTATO RIALZATO CON DUE PORTE LATERALI' },
  { key: 'GW', label: 'FURGONE RIALZATO FINESTRATO' },
  { key: 'GX', label: 'FURGONE RIALZATO FINESTRATO' },
  { key: 'GY', label: 'FURGONE RIALZATO' },
  { key: 'GZ', label: 'FURGONE COIBENTATO RIALZATO CON UNA PORTA LATERALE' },
  { key: 'H0', label: 'FURGONE RIALZATO VETRINATO' },
  { key: 'H1', label: 'FURGONE BLINDATO' },
  { key: 'IA', label: 'CHIUSA TIPO GIARDINETTA 3 PORTE' },
  { key: 'IB', label: 'CHIUSA TIPO GIARDINETTA 5 PORTE' },
  { key: 'IC', label: 'CHIUSA TRASFORMABILE 3 PORTE' },
  { key: 'ID', label: 'CHIUSA TRASFORMABILE 5 PORTE' },
  { key: 'J1', label: 'ATTREZZATA PER TRASPORTO DI IMBARCAZIONI' },
  { key: 'J2', label: 'ATTREZZATA PER TRASPORTO DI ALIANTI' },
  { key: 'J3', label: 'ATTREZZATA PER TRASPORTO DI MOTOCICLI' },
  { key: 'J4', label: 'ATTREZZATA PER TRASPORTO DI AUTOVEICOLI' },
  { key: 'J5', label: 'ATTREZZATA PER TRASPORTO DI ANIMALI PER USO SPORTIVO' },
  { key: 'J6', label: 'ATTREZZATA CON TENDA PER CAMPEGGIO' },
  { key: 'J7', label: 'CHIUSA CON ATTREZZATURA PERMANENTE AL TRASPORTO E ALLOGGIO' },
  { key: 'J8', label: 'CHIUSA CON AVANCORPO CON ATTREZZATURA PERMANENTE AL TRASPORTO E ALLOGGIO' },
  { key: 'JA', label: 'ATTREZZATO - VEDI DI SEGUITO DESCRIZIONE ATTREZZATURE' },
  { key: 'JS', label: 'AUTOAMBULANZA DI SOCCORSO' },
  { key: 'JT', label: 'AUTOAMBULANZA DI TRASPORTO' },
  { key: 'K0', label: 'CASSONE' },
  { key: 'K1', label: 'CASSONE CON CENTINATURA INAMOVIBILE' },
  { key: 'K2', label: 'CASSONE CON CENTINATURA INAMOVIBILE TELONE FISSO E PORTA POSTERIORE' },
  { key: 'K3', label: 'CASSONE CON SPONDA CARICATRICE' },
  { key: 'K4', label: 'CASSONE CON CENTINATURA INAMOVIBILE E SPONDA POSTERIORE CARICATRICE' },
  { key: 'K5', label: 'CASSONE CON GRU APPLICATA SUL TELAIO DIETRO LA CABINA' },
  { key: 'K6', label: 'CASSONE ATTREZZATO PER TRASPORTO DI LATTE IN BIDONI' },
  { key: 'K7', label: 'CASSONE RIBASSATO' },
  { key: 'K8', label: 'CASSONE ALLUNGATO CON CABINA CORTA' },
  { key: 'K9', label: 'CASSONE CON CABINA ALLUNGATA' },
  { key: 'KA', label: 'CASSONE ALLARGATO' },
  { key: 'KB', label: 'CASSONE CON CENTINE E TELONE ATTREZZATO PER TRASPORTO DI ANIMALI VIVI' },
  { key: 'KC', label: 'CASSONE CON CENTINE E TELONE INAMOVIBILI' },
  { key: 'KD', label: 'CASSONE CON DOPPIO PIANALE' },
  { key: 'KE', label: 'CASSONE CON CABINA ALLUNGATA CON DOPPIO PIANALE' },
  { key: 'KF', label: 'CASSONE CON PIANALE BASSO E VERRICELLO' },
  { key: 'KG', label: 'CASSONE ALLARGATO CON DOPPIO PIANALE' },
  { key: 'KH', label: 'CASSONE CON DOPPIO PIANALE E PIANO DI CARICO SULLA CABINA' },
  { key: 'KI', label: 'CASSONE CON CENTINE E TELONE AD ALTEZZA VARIABILE' },
  { key: 'KJ', label: 'CASSONE CON GRU APPLICATA NELLA PARTE POSTERIORE DEL TELAIO' },
  { key: 'KK', label: 'CASSONE CON COPERTURA ASPORTABILE' },
  { key: 'KL', label: 'CASSONE CON CABINA ALLUNGATA CON DOPPIO PIANALE E PIANO DI CARICO SULLA CABINA' },
  { key: 'KM', label: 'CASSONE ALLARGATO CON DOPPIO PIANA LE E PIANO DI CARICO SULLA CABINA' },
  { key: 'KN', label: 'CASSONE DI COSTRUZIONE NAZIONALE' },
  { key: 'KP', label: 'CASSONE CON PIANO DI CARICO SULLA CABINA' },
  { key: 'KR', label: 'CASSONE CON PIANALE BASSO' },
  { key: 'KS', label: 'CASSONE CON PIANALE BASSO E CABINA ALLUNGATA' },
  { key: 'KT', label: 'CASSONE CON PIANALE BASSO E PIANO DI CARICO SULLA CABINA' },
  { key: 'KU', label: 'CASSONE CON CENTINE E TELONE' },
  { key: 'KV', label: 'CASSONE CON VERRICELLO' },
  { key: 'KW', label: 'CASSONE CON CENTINATURA INAMOVIBILE E PIANO DI CARICO SU CABINA' },
  { key: 'KX', label: 'CASSONE CON CENTINATURA FISSA E AVANCORPO SULLA CABINA' },
  { key: 'KY', label: 'CASSONE INTERCAMBIABILE CON ALTRI AVENTI LE STESSE CARATTERISTICHE' },
  { key: 'KZ', label: 'CASSONE ATTREZZATO PER TRASPORTO SPECIFICO DI' },
  { key: 'LF', label: "ATTREZZATA AL TRASPORTO DI PERSONE CON PIU' DI NOVE POSTI COMPRESO IL CONDUCENTE" },
  { key: 'M0', label: 'MOTOCICLO' },
  { key: 'M1', label: 'MOTOCICLO CON CARROZZINO LATERALE STACCABILE 1 POSTO' },
  { key: 'M2', label: 'MOTOCICLO CON CARROZZINO LATERALE STACCABILE 2 POSTI' },
  { key: 'M3', label: 'APERTA' },
  { key: 'M4', label: 'CHIUSA CARROZZINO POSTERIORE' },
  { key: 'M5', label: 'CHIUSA TRASFORMABILE' },
  { key: 'MA', label: 'CASSONE' },
  { key: 'MB', label: 'CASSONE' },
  { key: 'MC', label: 'CASSONE' },
  { key: 'MD', label: 'CASSONE' },
  { key: 'ME', label: 'CASSONE' },
  { key: 'MF', label: 'FURGONE' },
  { key: 'MG', label: 'FURGONE' },
  { key: 'MH', label: 'FURGONE' },
  { key: 'MI', label: 'MOTOCARROZZETTA SIMMETRICA 1 POSTO' },
  { key: 'MJ', label: 'CASSONE' },
  { key: 'MK', label: 'CASSONE' },
  { key: 'ML', label: 'FURGONE' },
  { key: 'MM', label: 'MOTOCARROZZETTA SIMMETRICA CHIUSA' },
  { key: 'MN', label: 'MOTOCARROZZETTA SIMMETRICA 2 POSTI IN LINEA' },
  { key: 'MP', label: 'MOTOCARROZZETTA SIMMETRICA APERTA' },
  { key: 'MQ', label: 'MOTOCARROZZETTA SIMMETRICA TRASFORMABILE' },
  { key: 'MR', label: 'CASSONE RIBALTABILE' },
  { key: 'MS', label: 'CASSONE RIBALTABILE' },
  { key: 'MT', label: 'MOTOTELAIO CABINATO' },
  { key: 'MU', label: 'MOTOTELAIO NON CABINATO' },
  { key: 'MX', label: 'PIANALE' },
  { key: 'MY', label: 'PIANALE' },
  { key: 'MZ', label: 'ATTREZZATA PER TRASPORTO SPECIFICO DI -*-' },
  { key: 'NA', label: 'CICLOMOTORE A DUE RUOTE' },
  { key: 'NB', label: 'CICLOMOTORE A TRE RUOTE' },
  { key: 'NC', label: 'QUADRICICLO LEGGERO - CARR. APERTA' },
  { key: 'ND', label: 'QUADRICICLO LEGGERO - CARR. CHIUSA' },
  { key: 'P0', label: 'PIANALE' },
  { key: 'P1', label: 'PIANALE ABBASSATO' },
  { key: 'P2', label: 'PIANALE RIBALTABILE' },
  { key: 'P3', label: 'PIANALE ATTREZZATO PER TRASPORTO SPECIFICO' },
  { key: 'P4', label: 'PIANALE ATTREZZATO CON CELLA COIBENTATA' },
  { key: 'P5', label: 'PIANALE ATTREZZATO CON CELLA COIBENTATA E CON GRUPPO REFRIGERANTE' },
  { key: 'P6', label: 'PIANALE CON SPONDA POSTERIORE CARICATRICE' },
  { key: 'P7', label: 'PIANALE CON GRU PER CARICO MERCE APPLICATA SU TELAIO DIETRO LA CABINA' },
  { key: 'P8', label: 'PIANALE ATTREZZATO PER TRASPORTO CONTENITORI DI LIQUIDI' },
  { key: 'P9', label: 'PIANALE CON CABINA ALLUNGATA' },
  { key: 'PA', label: 'PIANALE CON CABINA CORTA' },
  { key: 'PB', label: 'PIANALE ALLARGATO' },
  { key: 'PC', label: 'PIANALE RIBASSATO CABINA ALLUNGATA' },
  { key: 'PD', label: 'PIANALE DOPPIO' },
  { key: 'PE', label: 'PIANALE DOPPIO CABINA ALLUNGATA' },
  { key: 'PF', label: 'PIANALE CON SELLE PER TRASPORTO LAMIERE IN ROTOLI (COILS)' },
  { key: 'PG', label: 'PIANALE DOPPIO ALLARGATO' },
  { key: 'PH', label: 'PIANALE DOPPIO E PIANO DI CARICO SULLA CABINA' },
  { key: 'PL', label: 'PIANALE DOPPIO CON CABINA ALLUNGATA E PIANO DI CARICO SULLA CABINA' },
  { key: 'PM', label: 'PIANALE DOPPIO ALLARGATO E PIANO DI CARICO SULLA CABINA' },
  { key: 'PN', label: 'PIANALE DI COSTRUZIONE NAZIONALE' },
  { key: 'PP', label: 'PIANALE CON PIANO DI CARICO SULLA CABINA' },
  { key: 'PR', label: 'PIANALE CON CABINA CORTA E PIANO DI CARICO SULLA CABINA' },
  { key: 'PS', label: 'PIANALE CON CABINA ALLUNGATA E PIANO DI CARICO SULLA CABINA' },
  { key: 'PT', label: 'PIANALE CON CAVALETTO PER TRASP. DI MATERIALE IN LASTRE' },
  { key: 'PV', label: 'PIANALE CON VERRICELLO' },
  { key: 'PW', label: 'PIANALE CON CAVALLETTI PER TRASP. ELEMENTI PREFABBRICATI' },
  { key: 'PX', label: 'PIANALE CON RALLA PER TRASPORTO ELEMENTI INDIVISIBILI' },
  { key: 'PY', label: 'PIANALE CON CAVALLETTI PER TRASP. CARTE O CARTONI' },
  { key: 'PZ', label: 'PIANALE ATTREZZATO PER TRASPORTO DI CONTAINERS' },
  { key: 'R0', label: 'CASSONE RIBALTABILE POSTERIORE CON COMANDO MECCANICO' },
  { key: 'R1', label: 'CASSONE RIBALTABILE POSTERIORE CON SERVOCOMANDO PNEUMATICO' },
  { key: 'R2', label: 'CASSONE RIBALTABILE LATERALE CON COMANDO MECCANICO' },
  { key: 'R3', label: 'CASSONE RIBALTABILE LATERALE CON SERVOCOMANDO PNEUMATICO' },
  { key: 'R4', label: 'CASSONE RIBALTABILE TRILATERALE CON COMANDO MECCANICO' },
  { key: 'R5', label: 'CASSONE RIBALTABILE TRILATERALE CON SERVOCOMANDO PNEUMATICO' },
  { key: 'R6', label: 'CASSONE RIBALTABILE POSTERIORE CON COMANDO MECCANICO E CON GRU PER CARICO MERCE' },
  { key: 'R7', label: 'CASSONE RIBALTABILE POSTERIORE CON SERVOCOMANDO PNEUMATICO E CON GRU PER CARICO MERCE' },
  { key: 'R8', label: 'CASSONE RIBALTABILE LATERALE CON COMANDO MECCANICO E CON GRU PER CARICO MERCE' },
  { key: 'R9', label: 'CASSONE RIBALTABILE LATERALE CON SERVOCOMANDO PNEUMATICO E CON GRU PER CARICO MERCE' },
  { key: 'RA', label: 'CASSONE RIBALTABILE TRILATERALE CON COMANDO MECCANICO E CON GRU PER CARICO MERCE' },
  { key: 'RB', label: 'CASSONE RIBALTABILE TRILATERALE CON SERVOCOMANDO PNEUMATICO E CON GRU PER CARICO MERCE' },
  { key: 'RC', label: 'CASSONE RIBALTABILE POSTERIORE' },
  { key: 'RD', label: 'CASSONE RIBALTABILE LATERALE' },
  { key: 'RE', label: 'CASSONE RIBALTABILE TRILATERALE' },
  { key: 'RF', label: 'CASSONE RIBALTABILE POSTERIORE CON CABINA ALLUNGATA' },
  { key: 'RG', label: 'CASSONE RIBALTABILE POSTERIORE CON GRU DIETRO LA CABINA' },
  { key: 'RH', label: 'CASSONE RIBALTABILE LATERALE CON GRU DIETRO LA CABINA' },
  { key: 'RJ', label: 'CASSONE RIBALTABILE TRILATERALE CON CABINA ALLUNGATA' },
  { key: 'RK', label: 'CASSONE RIBALTABILE LATERALE CON CABINA ALLUNGATA' },
  { key: 'RL', label: 'CASSONE RIBALTABILE TRILATERALE CON GRU DIETRO LA CABINA' },
  { key: 'RM', label: 'CASSONE RIBALTABILE' },
  { key: 'RN', label: 'CASSONE RIBALTABILE POSTERIORE RINFORZATO' },
  { key: 'RP', label: 'CASSONE RIBALTABILE LATERALE RINFORZATO' },
  { key: 'RQ', label: 'CASSONE RIBALTABILE TRILATERALE RINFORZATO' },
  { key: 'RR', label: 'CASSONE RIBALTABILE RINFORZATO' },
  { key: 'RS', label: 'CASSONE RIBALTABILE CON GRU PER CARICO DELLA MERCE' },
  { key: 'RT', label: 'CASSONE RIBALTABILE TRILATERALE RINFORZATO TIPO CAVA' },
  { key: 'S0', label: 'ATTREZZATURA PER TRASPORTO SPECIFICO DI -1- (VEDERE ANNOTAZIONI)' },
  { key: 'S1', label: 'CASSONE PER TRASPORTO BIDONI GPL VERTICALI UN SOLO STRATO (ADR.CLASSE ID ORD 7-18)' },
  { key: 'S2', label: 'CASSONE PER TRASPORTO PETROLI PER RISCALD.IN IDONEI FUSTI (ADR.CLASSE IIIA ORD 3-4)' },
  { key: 'S3', label: 'CASSONE ATTREZZATO CON CAVALLETTI PER TRASPORTO DI ELEMENTI PREFABBRICATI' },
  { key: 'S4', label: 'CASSONE ATTREZZATO CON CAVALLETTI PER TRASPORTO DI LASTRE DI MARMO O VETRO' },
  { key: 'S5', label: 'CASSONE ATTREZZATO CON CAVALLETTI PER TRASPORTO DI CARTA O CARTONI' },
  { key: 'S6', label: "CASSONE ATTREZZATO CON RULLI PER TRASPORTO PALLETS D'AEREO" },
  { key: 'S7', label: 'CASSONE ATTREZZATO PER TRASPORTO MERCI PERICOLOSE' },
  { key: 'S8', label: "PIANALE RIBALTABILE TRILATERALE PER TRASPORTO TRONCHI D'ALBERO" },
  { key: 'S9', label: 'PIANALE A GIORNO ATTREZZATO PER TRASPORTO TUBI E PROFILATI DI FERRO' },
  { key: 'SA', label: 'AUTOCARAVAN' },
  { key: 'SB', label: 'VEICOLI BLINDATI' },
  { key: 'SC', label: 'AMBULANZE' },
  { key: 'SD', label: 'AUTOFUNEBRE' },
  { key: 'SE', label: 'CARAVAN' },
  { key: 'SF', label: 'GRU MOBILI' },
  { key: 'SG', label: 'ALTRI VEICOLI PER USO SPECIALE' },
  { key: 'SH', label: 'VEICOLO CON ACCESSO PER SEDIE A ROTELLE' },
  { key: 'SK', label: 'PIANALE FISSO CON STANTI E GRU CARICATRICE' },
  { key: 'SL', label: 'SCARRABILE' },
  { key: 'SR', label: 'PIANALE CON ROTAIE PER TRASPORTO CARRI FERROVIARI' },
  { key: 'SS', label: 'ATTREZZATA PER TRASP. SPECIFICO DI MATERIALI DA FIERA PER SPETTACOLI VIAGGIANTI' },
  { key: 'SU', label: 'ATTREZZATO CON CUCINA' },
  { key: 'SV', label: 'ATTREZZATA AD ABITAZIONE PER USO ESCLUSIVO SPETTACOLI VIAGGIANTI' },
  { key: 'SX', label: 'ATTREZZATA CON ZAVORRA FISSA PER USO ESCLUSIVO AUTOSCUOLA' },
  { key: 'TA', label: 'AUTOTELAIO PER AUTOBUS URBANO O SUBURBANO' },
  { key: 'TR', label: 'TRICICLO' },
  { key: 'TS', label: 'CABINATO CON RALLA' },
  { key: 'U0', label: 'TELAIO PER RIMORCHIO' },
  { key: 'U1', label: 'CABINATO (AUTOTELAIO)' },
  { key: 'U2', label: 'AUTOTELAIO PER TRATTORE PER SEMIRIMORCHIO' },
  { key: 'U3', label: 'CHIUSA ATTREZZATA PER CAMPEGGIO' },
  { key: 'U4', label: 'ATTREZZATA CON POMPA PER CALCESTRUZZO' },
  { key: 'U5', label: 'AUTOAMBULANZA' },
  { key: 'U6', label: 'AMBULATORIO MOBILE' },
  { key: 'U7', label: 'AUTOFUNEBRE (PER TRASPORTO SALME)' },
  { key: 'U8', label: 'ATTREZZATA PER SOCCORSO STRADALE' },
  { key: 'U9', label: 'ANNAFFIATRICE STRADALE' },
  { key: 'UA', label: 'AUTOSCALA PER RIPARAZIONI LINEE ELETTRICHE' },
  { key: 'UB', label: 'AUTOTORRE PER RIPARAZIONI LINEE ELETTRICHE' },
  { key: 'UC', label: 'AUTOGRU' },
  { key: 'UD', label: 'FURGONE ATTREZZATO PER TRASPORTO DETENUTI' },
  { key: 'UE', label: 'FURGONE ATTREZZATO PER DISINFEZIONE' },
  { key: 'UF', label: 'FURGONE ATTREZZATO PER MOSTRA PUBBLICITARIA' },
  { key: 'UG', label: 'FURGONE ATTREZZ.PER USO ABITAZIONE' },
  { key: 'UH', label: 'FURGONE RIALZATO PER USO ABITAZIONE' },
  { key: 'UI', label: 'ATTREZZATA PER USO ANTINCENDIO' },
  { key: 'UJ', label: 'CARAVAN - CHIUSA ATTREZZATA PER CAMPEGGIO' },
  { key: 'UK', label: 'CASSONE CHIUSO ATTREZZATO PER CAMPEGGIO' },
  { key: 'UL', label: 'FURGONE A TETTO RIALZATO' },
  { key: 'UM', label: 'FURGONE FINESTRATO RIALZATO ATTREZZATO PER CAMPEGGIO' },
  { key: 'UN', label: 'ATTREZZATA PER USO ESCLUSIVO AUTOSCUOLA' },
  { key: 'UO', label: 'TRASPORTO ATTREZZATURE TURISTICHE E SPORTIVE' },
  { key: 'UP', label: 'ATTREZZATA PER CAMPEGGIO CON AVANCORPO' },
  { key: 'UQ', label: 'ATTREZZATA PER TRASPORTO ALIANTI' },
  { key: 'UR', label: 'AUTOAMBULANZA CON TETTO RIALZATO' },
  { key: 'US', label: 'ATTREZZATA CON SCALA' },
  { key: 'UT', label: 'ATTREZZATA PER RIPARAZIONI LINEE ELETTRICHE' },
  { key: 'UU', label: 'FURGONE FINESTRATO ATTREZZATO PER USO CAMPEGGIO' },
  { key: 'UV', label: 'ATTREZZATA PER DISINFEZIONI' },
  { key: 'UW', label: 'ATTREZZATA PER TRASPORTO IMBARCAZIONI' },
  { key: 'UX', label: 'ATTREZZATA PER MOSTRA PUBBLICITARIA' },
  { key: 'UY', label: 'ATTREZZATA CON GRU PER SOCCORSO STRADALE' },
  { key: 'UZ', label: 'ATTREZZATA PER ANTINCENDIO' },
  { key: 'VA', label: 'CISTERNA PER TRASPORTO DI GAS COMPRESSI' },
  { key: 'VB', label: 'CISTERNA PER TRASPORTO DI GAS LIQUEFATTI' },
  { key: 'VC', label: 'TELAIO ATTREZZATO PER TRASPORTO DI CONTAINERS' },
  { key: 'VD', label: 'BOTTE KILOLITRICA PER TRASPORTO OLII MINERALI E CARBURANTI' },
  { key: 'VE', label: 'FURGONE ATTREZZATO PER TRASPORTO ESPLOSIVI' },
  { key: 'VF', label: 'CISTERNA ORIZZONTALE PER TRASPORTO GRANULATI' },
  { key: 'VG', label: 'FURGONE ATTREZZATO PER TRASPORTO MERCI PERICOLOSE' },
  { key: 'VH', label: 'PIANALE ATTREZZATO PER TRASPORTO DI MERCI PERICOLOSE NON INFIAMMABILI' },
  { key: 'VI', label: 'FURGONE ISOTERMICO CON SPONDA POSTERIORE CARICATRICE' },
  { key: 'VL', label: 'PIANALE ATTREZZATO PER TRASPORTO DI LATTE ALIMENTARE' },
  { key: 'VM', label: 'PIANALE ATTREZZATO PER TRASPORTO DI LATTE USO INDUSTRIALE' },
  { key: 'VN', label: 'CISTERNA' },
  { key: 'VP', label: 'CISTERNA COIBENTATA PER TRASPORTO PRODOTTI BITUMINOSI' },
  { key: 'VR', label: 'FURGONE ATTREZZATO PER TRASPORTO MERCI PERICOLOSE RADIOATTIVE' },
  { key: 'VS', label: 'CISTERNA ATTREZZATA PER SPURGO POZZI NERI' },
  { key: 'VT', label: 'FURGONE ISOTERMICO CON GRUPPO REFRIGERANTE E SPONDA POSTERIORE CARICATRICE' },
  { key: 'XA', label: 'PIANALE ATTREZZATO CON CENTINATURA PER TRASPORTO DI BOMBOLE DI' },
  { key: 'ME', label: 'ANO O IDROGENO' },
  { key: 'XB', label: 'PIANALE CON GUIDE PER TRASPORTO CONTENITORI DI CALCE DOLOMITE O PIETRISCO' },
  { key: 'XC', label: "PIANALE ATTREZZATO CON RULLI PER TRASPORTO PALLETS D'AEREO" },
  { key: 'XD', label: 'PIANALE ATTREZZATO PER TRASPORTO VEICOLI' },
  { key: 'XE', label: 'PIANALE DOPPIO ATTREZZATO PER TRASPORTO VEICOLI' },
  { key: 'XF', label: 'VEICOLO ZAVORRATO' },
  { key: 'XG', label: 'PIANALE ATTREZZATO PER TRASPORTO IMBARCAZIONI' },
  { key: 'Z0', label: 'Vedere annotazioni sul libretto di circolazione (veicoli con particolari caratteristiche tecniche)' },
  { key: 'ZO', label: 'Vedere annotazioni sul libretto di circolazione (veicoli con particolari caratteristiche tecniche)' },
  { key: 'ZZ', label: 'Vedere annotazioni sul libretto di circolazione (veicoli con particolari caratteristiche tecniche)' },
  { key: 'CX', label: 'TELAIO PER AUTOBUS' },
  { key: 'XH', label: 'PIANALE FISSO CON STANTI' },
  { key: 'YA', label: 'A UN PIANO DI CLASSE I' },
  { key: 'YB', label: 'A DUE PIANI DI CLASSE I' },
  { key: 'YC', label: 'AUTOSNODATO A UN PIANO DI CLASSE I ' },
  { key: 'YD', label: 'AUTOSNODATO A DUE PIANI DI CLASSE I ' },
  { key: 'YE', label: 'A UN PIANO E PIANALE RIBASSATO DI CLASSE I' },
  { key: 'YF', label: 'A DUE PIANI E PIANALE RIBASSATO DI CLASSE I' },
  { key: 'YG', label: 'AUTOSNODATO A UN PIANO E PIANALE RIBASSATO DI CLASSE I' },
  { key: 'YH', label: 'AUTOSNODATO A DUE PIANI E PIANALE RIBASSATO DI CLASSE I' },
  { key: 'YI', label: 'A UN PIANO DI CLASSE II' },
  { key: 'YJ', label: 'A DUE PIANI DI CLASSE II' },
  { key: 'YK', label: 'AUTOSNODATO A UN PIANO DI CLASSE II' },
  { key: 'YL', label: 'AUTOSNODATO A DUE PIANI DI CLASSE II' },
  { key: 'YM', label: 'A UN PIANO E PIANALE RIBASSATO DI CLASSE II' },
  { key: 'YN', label: 'A DUE PIANI E PIANALE RIBASSATO DI CLASSE II' },
  { key: 'YO', label: 'AUTOSNODATO A UN PIANO E PIANALE RIBASSATO DI CLASSE II' },
  { key: 'YP', label: 'AUTOSNODATO A DUE PIANI E PIANALE RIBASSATO DI CLASSE II' },
  { key: 'YQ', label: 'AUTOBUS A UN PIANO DI CLASSE III' },
  { key: 'YR', label: 'AUTOBUS A DUE PIANI DI CLASSE III' },
  { key: 'YS', label: 'AUTOSNODATO A UN PIANO DI CLASSE III' },
  { key: 'YT', label: 'AUTOSNODATO A DUE PIANI DI CLASSE III' },
  { key: 'YU', label: 'AUTOBUS A UN PIANO DI CLASSE A' },
  { key: 'YV', label: 'AUTOBUS A UN PIANO E PIANALE RIBASSATO DI CLASSE A' },
  { key: 'YW', label: 'AUTOBUS A UN PIANO DI CLASSE B' },
  { key: 'BX', label: 'TELAIO CABINATO O TELAIO COPERTO' },
  { key: 'IE', label: 'CHIUSA 3 PORTE' },
  { key: 'IS', label: 'TRATTORE STRADALE PER TRENINI TURISTICI' }
];

export const CAUSALE_CARTA_NON_CICLOMOTORI_PROPS = [
  { label: 'DETERIORAMENTO', key: '10' },
  { label: 'VEICOLO ISCRITTO AL P.R.A. (ART. 80 C. 57 L. 289/02)', key: '11' },
  { label: 'TARGA CESSATA PER MANCATA PRESENTAZIONE ATTO DI VENDITA', key: '12' },
  { label: 'TARGA CESSATA PER DOCUMENTAZIONE INCOMPLETA O NON CONFORME', key: '13' },
  { label: 'CESSAZIONE PER REIMMATRICOLAZIONE', key: '14' },
  { label: 'CESSAZIONE PER INTESTAZIONE FITTIZIA', key: '15' },
  { label: "PASSAGGIO DI PROPRIETA'", key: '20' },
  { label: "CAMBIO DESTINAZIONE E PASS PROPRIETA'", key: '21' },
  { label: 'ISCRIZIONE REGISTRO VEICOLI INTERESSE STORICO E COLLEZIONISTICO', key: '22' },
  { label: 'CLASSIFICAZIONE VEICOLI INTERESSE STORICO E COLLEZIONISTICO', key: '23' },
  { label: 'CAMBIO DI RESIDENZA', key: '30' },
  { label: 'REVISIONE', key: '31' },
  { label: 'INSTALLAZIONE IMPIANTO GPL', key: '40' },
  { label: 'INSTALLAZIONE DOPPI COMANDI PER VEICOLI DA ADIBIRE AD ESERCITAZIONI DI GUIDA', key: '41' },
  { label: 'INSTALLAZIONE DISPOSITIVI PER LA GUIDA DEI VEICOLI DA PARTE DI CONDUCENTI DISABILI', key: '42' },
  { label: 'SOSTITUZIONE SERBATOIO PER I VEICOLI DOTATI DI IMP. GPL (NO COLLAUDO)', key: '43' },
  { label: 'INSTALLAZIONE GANCIO (NO COLLAUDO)', key: '44' },
  { label: 'INSTALLAZIONE DISPOSITIVO ANTINQUINAMENTO (FAP)', key: '45' },
  { label: 'INTEGRAZIONE RIGHE DESCRITTIVE DI IMMATRICOLAZIONE', key: '46' },
  { label: 'INTEGRAZIONE PNEUMATICI', key: '47' },
  { label: 'SOSTITUZIONE BOMBOLE PER I VEICOLI DOTATI DI IMP. A METANO', key: '48' },
  { label: 'SOSTITUZIONE BOMBOLE PER I VEICOLI DOTATI DI IMP. GPL', key: '49' },
  { label: 'DISINSTALLAZIONE IMPIANTO GPL', key: '50' },
  { label: 'AGGIORNAMENTO DELLA CARTA DI CIRCOLAZIONE PER MODIFICA DENOMINAZIONE SOCIALE', key: '51' },
  { label: "AGGIORNAMENTO DELLA CARTA DI CIRCOLAZIONE PER INTESTAZIONE TEMPORANEA (VEICOLI IN COMODATO D'USO)", key: '52' },
  { label: 'EMISSIONE RICEVUTA PER LOCAZIONI PER PERIODI SUPERIORI AI 30 GIORNI', key: '53' },
  { label: 'LOCAZIONE DI VEICOLI PER USO ESCLUSIVO DI POLIZIA', key: '54' },
  { label: 'INSTALLAZIONE SPECCHI', key: '55' },
  { label: 'AGGIORNAMENTO DELLA CARTA DI CIRCOLAZIONE PER INTESTAZIONE A TUTORE PER TUTELA SOGGETTI INCAPACI', key: '56' },
  { label: 'AGGIORNAMENTO DELLA CARTA DI CIRCOLAZIONE PER INTESTAZIONE TEMPORANEA A SOGGETTO DIVERSO DALL’INTESTATARIO', key: '57' },
  { label: 'AGGIORNAMENTO DELLA CARTA DI CIRCOLAZIONE PER INTESTAZIONE TEMPORANEA (VEICOLI IN CUSTODIA GIUDIZIALE)', key: '58' },
  { label: 'ELIMINAZIONE INTESTATARIO PROVVISORIO', key: '59' },
  { label: 'INSTALLAZIONE GANCIO', key: '60' },
  { label: "PASSAGGIO DI PROPRIETA' EX LOCAZIONE DI VEICOLI PER USO ESCLUSIVO DI POLIZIA", key: '61' },
  { label: 'EX LOCAZIONE DI VEICOLI PER USO ESCLUSIVO DI POLIZIA', key: '62' },
  { label: 'AGGIORNAMENTO DATI TECNICI VEICOLO INTESTAZIONE PROVVISORIA', key: '63' },
  { label: 'AGGIORNAMENTO DELLA CARTA DI CIRCOLAZIONE PER DELEGA POTERI DEL TRUSTEE', key: '64' },
  { label: 'ANNULLAMENTO MASSA RIMORCHIABILE', key: '65' },
  { label: 'AGGIORNAMENTO DELLA CARTA DI CIRCOLAZIONE PER INIZIO LOCAZIONE RENT TO BUY', key: '66' },
  { label: 'EMISSIONE RICEVUTA PER SUB-LOCAZIONI PER PERIODI SUPERIORI AI 30 GIORNI', key: '67' },
  { label: 'EMISSIONE RICEVUTA PER SUB-COMODATI PER PERIODI SUPERIORI AI 30 GIORNI', key: '68' },
  { label: 'INSTALLAZIONE DISPOSITIVI DI SCARICO', key: '70' },
  { label: 'RIENTRO IN POSSESSO DEL VEICOLO ACQUISITO DA ACI', key: '77' },
  { label: 'RIENTRO IN POSSESSO DEL VEICOLO ACQUISITO DA UP', key: '78' },
  { label: 'PERDITA DI POSSESSO DEL VEICOLO ACQUISITA DA AC', key: '79' },
  { label: 'MODIFICA CARATTERISTICHE COSTRUTTORI', key: '80' },
  { label: 'CAMBIO DESTINAZIONE/USO', key: '81' },
  { label: 'CAMBIO DESTINAZIONE', key: '82' },
  { label: 'CAMBIO USO', key: '83' },
  { label: 'RADIAZIONE PER ESPORTAZIONE IN ALTRO PAESE UE', key: '84' },
  { label: 'RADIAZIONE PER DEMOLIZIONE', key: '85' },
  { label: 'RADIAZIONE PER ESPORTAZIONE IN ALTRO PAESE NON UE', key: '86' },
  { label: 'CESSAZIONE PER PERDITA DI POSSESSO', key: '87' },
  { label: 'CESSAZIONE MCTC ONLINE', key: '88' },
  { label: 'RADIAZIONE GENERICA (MCTC ONLINE - ACI BATCH)', key: '89' },
  { label: 'INSTALLAZIONE IMPIANTO METANO', key: '90' },
  { label: 'MACCHINA AGRICOLA CESSATA DALLA CIRCOLAZIONE STRADALE', key: '91' },
  { label: 'MODIFICA DATI TECNICI DA TRANSAZIONE ON LINE', key: '92' },
  { label: 'RIPUNZONATURA TELAIO', key: '93' },
  { label: 'AGGIORNAMENTO SISTEMA RUOTA EX ART. 78 C.D.S.', key: '94' },
  { label: 'DISINSTALLAZIONE IMPIANTO METANO', key: '95' },
  { label: 'INSTALLAZIONE LUCE DIURNA', key: '96' },
  { label: 'INSTALLAZIONE LUCE DIURNA A SEGUITO COLLAUDO', key: '97' },
  { label: 'RETTIFICA COC', key: '98' },
  { label: 'ALTRI CASI', key: '99' }
];

export const CAUSALE_CARTA_CICLOMOTORI_PROPS = [
  { label: 'FURTO O SMARRIMENTO', key: '10' },
  { label: 'VARIAZIONE DATI TECNICI', key: '15' },
  { label: 'DETERIORAMENTO', key: '20' },
  { label: 'DUPLICATO PER CAMBIO USO', key: '25' },
  { label: 'TAGLIANDO CAMBIO DI RESIDENZA', key: '30' },
  { label: 'REVISIONE', key: '31' },
  { label: 'DUPLICATO PER RIATTIVAZIONE POST RADIAZIONE', key: '35' },
  { label: 'DUPLICATO PER RIATTIVAZIONE POST SOSPENSIONE', key: '40' },
  { label: 'NUOVA TARGATURA POST SOSPENSIONE', key: '50' },
  { label: 'NUOVA TARGATURA POST FURTO', key: '60' },
  { label: 'RADIAZIONE PER FURTO', key: '70' },
  { label: 'RADIAZIONE PER DEMOLIZIONE', key: '80' },
  { label: "RADIAZIONE PER ESPORTAZIONE ALL'ESTERO", key: '90' },
  { label: 'RADIAZIONE PER TELAIO CONTRAFFATTO', key: '91' },
  { label: 'RADIAZIONE PER ESPORTAZIONE DEFINITIVA IN ALTRO PAESE DELLA U.E.', key: '92' },
  { label: 'RADIAZIONE PER ESPORTAZIONE DEFINITIVA IN ALTRO PAESE NON FACENTE PARTE DELLA U.E.', key: '93' },
  { label: 'RADIAZIONE PER PERDITA DI POSSESSO', key: '94' },
  { label: 'ALTRI CASI', key: '99' }
];

export const FORMA_TARIFFARIA_PROPS = [
  { label: 'Bonus Malus', key: '01' },
  { label: 'Franchigia', key: '02' },
  { label: 'Pejus', key: '03' },
  { label: 'Mista franchigia + bonus malus o no claim discount', key: '04' },
  { label: 'No claim discount', key: '05' },
  { label: 'Fissa', key: '06' },
  { label: 'Altre', key: '09' }
];

export const MOD_PAGAMENTO_PROPS = [
  { label: 'Contanti', key: '1' },
  { label: 'Assegno', key: '2' },
  { label: 'Carta di credito/bancomat', key: '3' },
  { label: 'Bonifico bancario', key: '4' },
  { label: 'Conto corrente postale', key: '5' },
  { label: 'Addebito in conto corrente ', key: '6' },
  { label: 'Altra modalità di pagamento', key: '9' }
];

export const COD_PROV_VEIC_PROPS = [
  { label: 'Non indicata', key: '' },
  { label: 'Italiana', key: 'I' },
  { label: 'Estera', key: 'E' },
  { label: 'IMPORTAZIONE PARALLELA', key: '*' },
  { label: 'IMPORTAZIONE PARALLELA', key: '+' },
  { label: 'IMPORTAZIONE PARALLELA', key: 'X' }
];

export const SPEC_CARROZZERIA_PROPS = [
  { label: 'FONDO PIATTO', key: '01' },
  { label: 'SPONDA RIBALTABILE', key: '02' },
  { label: 'CASSONE CHIUSO', key: '03' },
  { label: 'CONDIZIONATO, CON PARETI ISOLATE E ATTREZZATO PER MANTENERE LA TEMPERATURA INTERNA', key: '04' },
  { label: 'CONDIZIONATO, CON PARETI ISOLATE, MA NON ATTREZZATO PER MANTENERE LA TEMPERATURA INTERNA', key: '05' },
  { label: 'COPERTO DA TELONE', key: '06' },
  { label: 'CASSA MOBILE (SOVRASTRUTTURA INTERCAMBIABILE)', key: '07' },
  { label: 'PORTACONTAINER', key: '08' },
  { label: 'VEICOLI MUNITI DI GANCIO DI SOLLEVAMENTO', key: '09' },
  { label: 'A CASSONE RIBALTABILE', key: '10' },
  { label: 'CISTERNA', key: '11' },
  { label: 'CISTERNA DESTINATA AL TRASPORTO DI MERCI PERICOLOSE', key: '12' },
  { label: 'CAMION PER IL TRASPORTO DI BESTIAME', key: '13' },
  { label: 'BISARCA', key: '14' },
  { label: 'CAMION BETONIERA', key: '15' },
  { label: 'AUTOPOMPA PER CALCESTRUZZO', key: '16' },
  { label: 'CAMION PER IL TRASPORTO DI LEGNAME', key: '17' },
  { label: 'VEICOLO PER LA RACCOLTA DEI RIFIUTI', key: '18' },
  { label: 'SPAZZATRICE, PULITRICE E SPURGO POZZI NERI', key: '19' },
  { label: 'COMPRESSORE', key: '20' },
  { label: 'PORTA-BARCHE', key: '21' },
  { label: 'PORTA-ALIANTI', key: '22' },
  { label: 'VEICOLI DESTINATI ALLA VENDITA AL DETTAGLIO O DA ESPOSIZIONE', key: '23' },
  { label: 'CARROATTREZZI', key: '24' },
  { label: 'CAMION CON SCALA', key: '25' },
  { label: "AUTOGRU (DIVERSA DA UNA GRU MOBILE COME DEFINITA NELLA SEZIONE 5, PARTE A, DELL'ALLEGATO II)", key: '26' },
  { label: 'CAMION CON PIATTAFORMA AEREA', key: '27' },
  { label: 'GRU SCAVATRICE', key: '28' },
  { label: 'RIMORCHIO A PIANALE RIBASSATO', key: '30' },
  { label: 'CAMION DEI POMPIERI', key: '31' },
  { label: 'CARROZZERIA ESCLUSA DAL PRESENTE ELENCO', key: '99' }
];

export const TIPO_DENOMINAZIONE_PROPS = [
  { label: "SOCIETA' PER AZIONI", key: 'SPA' },
  { label: "SOCIETA' IN NOME COLLETTIVO", key: 'SNC' },
  { label: "SOCIETA' RESPONSABILITA’ LIMITATA", key: 'SRL' },
  { label: "SOCIETA' IN ACCOMANDITA SEMPLICE", key: 'SAS' },
  { label: "SOCIETA' IN ACCOMANDITA PER AZIONI", key: 'SAA' },
  { label: "SOCIETA' SEMPLICE", key: 'SOS' },
  { label: 'MINISTERO', key: 'MIN' },
  { label: 'REGIONE', key: 'REG' },
  { label: 'PROVINCIA', key: 'PRO' },
  { label: 'COMUNE', key: 'COM' },
  { label: 'ENTI RICONOSCIUTI', key: 'EAS' },
  { label: 'ENTI NON RICONOSCIUTI', key: 'ENR' },
  { label: 'IMPRESE E SOCIETA’ ESTERE', key: 'ISE' },
  { label: 'SOCIETA’ COOP. A RESPONSABILITA’ ILLIMITATA', key: 'RIC' },
  { label: 'SOC. COOP. RESP. LIMITATA', key: 'RLC' },
  { label: 'SOC.COOP.PER AZIONI', key: 'AZC' },
  { label: 'AZIENDA AGRICOLA', key: 'AA' },
  { label: 'IMPRESA DI MANUTENZIONE STRADALE', key: 'IM' },
  { label: 'IMPRESA DI LOCAZIONE', key: 'IL' },
  { label: 'CONSORZIO', key: 'COP' },
  { label: 'COOPERATIVA', key: 'CON' },
  { label: 'AZIENDA SPECIALE', key: 'ASP' },
  { label: "SOCIETA' AGRICOLA", key: 'SAG' },
  { label: "SOCIETA' COOPERATIVA AGRICOLA", key: 'SCA' },
  { label: 'SOC. CONS. RESP. LIMITATA', key: 'SCL' },
  { label: "SOCIETA' COOPERATIVA CONSORTILE", key: 'SCC' },
  { label: "SOCIETA' COOPERATIVA", key: 'SCP' },
  { label: 'ENTE PUBBLICO', key: 'EPR' },
  { label: "SOCIETA' SEMPLIFICATA A RESPONSABILITA' LIMITATA", key: 'SPL' },
  { label: 'TRUST', key: 'TRT' },
  { label: 'GRUPPO EUROPEO DI INTERESSE ECONOMICO', key: 'GEE' },
  { label: "SOC. RESPONSABILITA' LIMITATA A CAPITALE RIDOTTO", key: 'SRC' },
  { label: "SOCIETA' PER AZIONI UNIPERSONALE", key: 'SPU' },
  { label: 'COOPERATIVA SOCIALE', key: 'OOO' },
  { label: 'SOC.COOP.PER AZIONI', key: 'AZC' },
  { label: 'LOCATARIO', key: 'LOC' },
  { label: 'INTESTATARIO PROVVISORIO', key: 'IPV' },
  { label: 'PATTO RISERVATO DOMINIO', key: 'RSD' },
  { label: 'USUFRUTTUARIO', key: 'USU' },
  { label: 'COMMERCIANTI', key: 'CO' },
  { label: 'SOGGETTI PRIVATI', key: 'FH' },
  { label: 'RETE IMPRESE', key: 'RI' }
];

export const TIPO_POLIZZA_PROPS = [
  { label: 'Polizza annuale/pluriennale', key: '0' },
  { label: 'Polizza flotta/libro matricola', key: '1' },
  { label: 'Polizza temporanea', key: '2' }
];

export const TIPOLOGIA_SINISTRI_PROPS = [
  { label: 'Sinistri pagati con responsabilità principale', key: '01' },
  { label: 'Con danni a cose', key: '1C' },
  { label: 'Con danni a persone', key: '1P' },
  { label: 'Con danni a cose e persone', key: '1M' },
  { label: 'Sinistri pagati con responsabilità paritaria', key: '02' },
  { label: 'Con danni a cose', key: '2C' },
  { label: 'Con danni a persone', key: '2P' },
  { label: 'Con danni a cose e persone', key: '2M' }
];

export const TIPO_MOVIMENTO_PROPS = [
  { label: 'Comunicazione Copertura', key: 'C', causaleProps: [
    { label: 'Copertura (nuova, rata successiva o rinnovo)', key: '0' },
    { label: 'Riattivazione dopo sospensione', key: '1' }
  ]},
  { label: 'Interruzione Copertura', key: 'I', causaleProps: [
    { label: 'Furto', key: '1' },
    { label: 'Sostituzione', key: '2' },
    { label: 'Temporanea inefficacia del contratto per alienazione, demolizione ecc. del veicolo', key: '3' },
    { label: 'Ai sensi dell’art. 122 bis del Codice delle assicurazioni - CAP', key: 'L' },
    { label: 'Cessione veicolo', key: '4' },
    { label: 'Ripensamento / risoluzione', key: '5' },
    { label: 'Cessazione', key: '6' },
    { label: 'Demolizione / esportazione', key: '9' },
    { label: 'Disdetta a scadenza', key: 'A(°)'},
    { label: 'Disdetta da parte dell’impresa', key: 'B(°)'},
    { label: 'Disdetta da parte dell’assicurato', key: 'C(°)'},
    { label: 'Mancato pagamento di una rata successiva alla prima', key: 'D'},
    { label: 'Cambio compagnia', key: 'E'},
  ]},
  { label: 'Completamento Dati', key: 'R', causaleProps: [
    { label: 'Completamento dati', key: '0' },
  ] },
];


//da vedere
export const TIPO_MOVIMENTO_PROPS_ATRC = [
  { label: 'Comunicazione Copertura', key: 'C' },
  { label: 'Interruzione Copertura', key: 'I' },
  { label: 'Completamento Dati', key: 'R' }
];

export const COMPANY_CODES_PROPS = [
  { key: '001', label: 'AXA ASSICURAZIONI (EX UAP ITALIANA/ABEILLE) - 001' },
  { key: '003', label: 'ALLIANZ - 003' },
  { key: '004', label: 'GENERALI ITALIA / DIVISIONE INA ASSITALIA - 004' },
  { key: '005', label: 'GENERALI ITALIA - 005' },
  { key: '006', label: 'DUOMO UNI ONE ASS.NI (EX CASSA GENERALE) - 006' },
  { key: '007', label: 'UNIPOLSAI EX MILANO - 007' },
  { key: '008', label: 'GENERALI ITALIA / DIVISIONE TORO - 008' },
  { key: '009', label: 'ASSICURAZIONI M.A.A. - 009' },
  { key: '010', label: 'FUSA IN UNIPOL(EX MEIEAURORA/AURORA ASS.NI) - 010' },
  { key: '011', label: 'HELVETIA (EX NORDSTERN) - 011' },
  { key: '012', label: 'COMPAGNIA TIRRENA DI ASSICURAZIONI - L.C.A.- - 012' },
  { key: '013', label: 'GROUPAMA ASS.NI SPA (EX GAN ITALIA/PHENIX SOLEIL) - 013' },
  { key: '014', label: 'AXA ASSICURAZIONI - 014' },
  { key: '015', label: 'ZURIGO COMPAGNIA DI ASS.NI (EX DANUBIO) - 015' },
  { key: '016', label: 'FATA ASSICURAZIONI DANNI - 016' },
  { key: '018', label: 'UNIPOLSAI EX FONDIARIA - 018' },
  { key: '019', label: 'HELVETIA - COMPAGNIA SVIZZERA DI ASS.NI SA - 019' },
  { key: '020', label: 'DUOMO UNI ONE ASSICURAZIONI - 020' },
  { key: '021', label: 'ITALIANA ASS.NI S.P.A. (EX IST.IT.DI PREVIDENZA) - 021' },
  { key: '022', label: 'ITAS-IST.TRENTINO-ALTO ADIGE ASS.NI - 022' },
  { key: '023', label: 'ITALIANA ASSICURAZIONI - 023' },
  { key: '024', label: "ALLIANZ RAS (EX L'ITALICA) - 024" },
  { key: '025', label: 'FUSA IN UNIPOL(EX NAVALE/LA NATIONALE/MMI ASS.NI) - 025' },
  { key: '026', label: 'ALLIANZ SUBALPINA S.P.A. (EX ALLIANZ-PACE) - 026' },
  { key: '027', label: 'AXA ASSICURAZIONI (EX ALLSECURES ASS.NI) - 027' },
  { key: '028', label: 'RHONE MEDITERRANEE - L.C.A.- - 028' },
  { key: '029', label: 'MILANO ASS.NI (EX LLOYD INTERNAZ.LE) - 029' },
  { key: '030', label: 'ZURIGO COMPAGNIA DI ASS.NI (EX LA MINERVA) - 030' },
  { key: '031', label: 'ACE EUROPEAN GROUP LTD (EX CIGNA/RELIANCE INS.CO) - 031' },
  { key: '032', label: 'SARA ASSICURAZIONI - 032' },
  { key: '033', label: 'MILANO ASS.NI (EX COMP.IT.DI SICURTA) - 033' },
  { key: '034', label: 'UNIPOLSAI ASSICURAZIONI S.p.A. - 034' },
  { key: '035', label: "SOCIETA' REALE MUTUA DI ASS.NI - 035" },
  { key: '036', label: 'ALLIANZ / DIVISIONE SUBALPINA - 036' },
  { key: '037', label: "ALLIANZ RAS (EX LAVORO&SICURTA') - 037" },
  { key: '038', label: 'VITTORIA ASSICURAZIONI - 038' },
  { key: '039', label: 'FUSA IN UNIPOL(EX DIVISIONE AURORA) - 039' },
  { key: '040', label: 'ZURICH INSURANCE PLC (EX ZIC) - 040' },
  { key: '041', label: 'FUSA IN UNIPOL(EX AURORA/WINTERTHUR/VENETA) - 041' },
  { key: '042', label: 'MILANO ASS.NI (EX PREVIDENTE) - 042' },
  { key: '043', label: 'MILANO ASS.NI (EX COMPAGNIA LATINA) - 043' },
  { key: '044', label: 'AXA ASSICURAZIONI (EX UAP ITALIANA) - 044' },
  { key: '045', label: 'ASSICURAZIONI RISCHI AGRICOLI VMG 1857 - 045' },
  { key: '046', label: 'MILANO ASS.NI (EX RENANA) - 046' },
  { key: '047', label: 'CARIGE ASS.NI (EX LEVANTE NORDITALIA/ROYALE BELGE) - 047' },
  { key: '048', label: "S.I.D.A. SOCIETA' ITALIANA DI ASS.NI - L.C.A.- - 048" },
  { key: '049', label: 'FUSA IN UNIPOL(EX NAVALE) - 049' },
  { key: '050', label: 'ALLIANZ SUBALPINA SPA (EX UNIONE SUBALPINA) - 050' },
  { key: '051', label: 'ZURIGO COMPAGNIA DI ASS.NI (EX ALPINA) - 051' },
  { key: '053', label: 'AUSONIA ASSICURAZIONE - 053' },
  { key: '054', label: 'AIG EUROPE (EX NATIONAL UNION FIRE ) - 054' },
  { key: '055', label: 'MEDIOLANUM ASSICURAZIONI - 055' },
  { key: '056', label: 'UNIQA ASSICURAZIONI - 056' },
  { key: '057', label: "SOCIETA' CATTOLICA DI ASSICURAZIONE - 057" },
  { key: '059', label: 'MILL RI - GRUPPO RIASSICURAT. - 059' },
  { key: '060', label: "L'EDERA COMP. IT. DI ASS.NE SPA - L.C.A.- - 060" },
  { key: '062', label: 'LA FONDIARIA (EX ITALIA ASS.NI) - 062' },
  { key: '063', label: 'GUARDIAN ROYAL EXCHANGE ASS.NI PLC. - L.C.A.- - 063' },
  { key: '064', label: 'ANCORA ITALIANA - 064' },
  { key: '066', label: 'ALLIANZ RAS (EX MUTUA COTONI/L&S) - 066' },
  { key: '068', label: 'FUSA IN UNIPOL(EX AURORA/MEIEAURORA/MEIE ASS.CE) - 068' },
  { key: '070', label: 'AIG EUROPE (EX UNAT/NEW HAMPSHIRE) - 070' },
  { key: '071', label: 'COMMERCIAL UNION ASS.NI (EX THE NORTHERN-ASSURANCE - 071' },
  { key: '072', label: 'ACE EUROPEAN GROUP LTD (EX CIGNA/INS.CO.OF N.A.) - 072' },
  { key: '073', label: 'MILANO ASS.NI (EX SIARCA-SICURMIL) - 073' },
  { key: '074', label: "SOCIETA'REALE MUTUA (EX LA PIEMONTESE SOC.MUTUA) - 074" },
  { key: '077', label: 'FUSA IN UNIPOL(EX AURORA/WINTERTHUR/SCHEWIZ/SAVOIA - 077' },
  { key: '078', label: 'THE SEA INSURANCE COMPANY - 078' },
  { key: '079', label: 'COMMERCIAL UNION ITALIA (EX SEVEN PROVINCES) - 079' },
  { key: '080', label: 'SUN INSURANCE OFFICE LIMITED - 080' },
  { key: '081', label: 'FUSA IN UNIPOL(EX AURORA/WINTERTHUR/SCHWEIZ) - 081' },
  { key: '082', label: 'UNIPOLSAI EX UNIPOL - 082' },
  { key: '083', label: 'SACE BT (EX SACE SURETY/ASSEDILE) - 083' },
  { key: '085', label: 'ASSICURATRICE VAL PIAVE - 085' },
  { key: '086', label: 'CARIGE R.D. ASSICURAZIONI E RIASS. - 086' },
  { key: '087', label: 'COMITAS-COMP.ITALIANA DI ASS.NI - L.C.A.- - 087' },
  { key: '088', label: 'LIGURIA - 088' },
  { key: '090', label: 'FUSA IN UNIPOL(EX NAVALE/SERI/SALDA/CAB/MMI DANNI) - 090' },
  { key: '092', label: 'CARIGE R.D. ASSICURAZIONI E RIASSICURAZIONI S.P.A. - 092' },
  { key: '093', label: 'COMMERCIAL UNION ITALIA S.P.A. (EX NORWICH UNION) - 093' },
  { key: '094', label: 'COMMERCIAL UNION ITALIA (EX GEAS/COMP.DI FIRENZE) - 094' },
  { key: '095', label: 'LA FONDIARIA (EX POLARIS/LA POTENZA) - 095' },
  { key: '096', label: 'LA FONDIARIA (EX POLARIS/CIDAS/PREVIDENZA&SICURTA) - 096' },
  { key: '097', label: 'FUSA IN UNIPOL(EX AURORA/WINTERTHUR/SAPA) - 097' },
  { key: '098', label: 'DUOMO UNI ONE ASS.NI (EX UNIASS/INTEREUROPEA) - 098' },
  { key: '100', label: 'FUSA IN UNIPOL(EX MEIEAURORA/AURORA/MUTUE RIUNITE) - 100' },
  { key: '102', label: 'ALLIANZ / DIVISIONE LLOYD ADRIATICO - 102' },
  { key: '104', label: 'FUSA IN UNIPOL(EX AURORA/WINTERTHUR/INTERCONT.) - 104' },
  { key: '105', label: 'AXA ASSICURAZIONI (EX UAP/ABEILLE ASS.CE) - 105' },
  { key: '106', label: 'UNIPOLSAI EX SASA - 106' },
  { key: '107', label: 'ABEILLE VIE - 107' },
  { key: '110', label: 'SINDACATO INTERN. ARMATORI - 110' },
  { key: '111', label: 'RSA (EX ALLIANCE) - 111' },
  { key: '112', label: 'DIALOGO ASSICURAZIONI - 112' },
  { key: '113', label: 'ATLANS - 113' },
  { key: '114', label: 'UMS GENERALI MARINE S.P.A. (EX MUTUAMAR) - 114' },
  { key: '115', label: "SOCIETA' ESERCENTI MUTUA ASSOCIAZIONE S.E.M.A.F. - 115" },
  { key: '116', label: 'SIAC ASSICURAZIONI SPA - L.C.A.- - 116' },
  { key: '117', label: 'EULER HERMES SIAC - SOC.IT.ASS.NE CREDITI S.P.A. - 117' },
  { key: '118', label: "ATRADIUS (EX SOCIETA' ITALIANA CAUZIONI - S.I.C.) - 118" },
  { key: '119', label: 'SOCIETA ITALO-AMERICANA ASS.NI E RIASS.NI - SIAR - 119' },
  { key: '120', label: "SOCIETA' MUTUA BESTIAME - 120" },
  { key: '122', label: "ELVIA ITALIA S.P.A. (EX COMP. EUROPEA D'ASS.NE) - 122" },
  { key: '123', label: 'LA CONSORZIALE SOC.IT.DI RIASS. - 123' },
  { key: '124', label: 'EAGLE STAR - L.C.A.- C/O ZURICH INSURANCE COMPANY - 124' },
  { key: '125', label: 'EUROPA TUTELA GIUDIZIARIA - 125' },
  { key: '127', label: 'UCA - ASSICURAZIONI SPESE LEGALI * - 127' },
  { key: '129', label: 'UNION ASS. PARIS-VIE - 129' },
  { key: '130', label: 'SWISS RE ITALIA (EX UNIONE ITALIANA DI RIASS.NE) - 130' },
  { key: '131', label: 'GENERALI ITALIA - OGM - 131' },
  { key: '133', label: 'HDI ASSICURAZIONI - 133' },
  { key: '135', label: 'ITALIANA VITA - 135' },
  { key: '137', label: 'ROYAL INT. INS. HOLDING - RAPPR.GEN.ITALIA - - 137' },
  { key: '138', label: 'LLOYD NAZIONALE ITALIANO - L.C.A.- - 138' },
  { key: '139', label: 'ALLIANZ DIRECT S.P.A - 139' },
  { key: '141', label: 'THE MARINE INSURANCE COMPANY LIMITED - 141' },
  { key: '142', label: 'D.A.S. - 142' },
  { key: '143', label: 'ZURICH INVESTMENTS LIFE - 143' },
  { key: '144', label: 'MIAS-MUTUA ITALIANA DI ASSICURAZIONI - L.C.A.- - 144' },
  { key: '145', label: 'MUTUELLE GENERALE FRANCAISE VIE - 145' },
  { key: '146', label: 'XL INSURANCE GLOBAL RISK (EX NEUCHATELOISE) - 146' },
  { key: '147', label: 'COMMERCIAL UNION ASS.NI (EX NORTH BRITISH) - 147' },
  { key: '149', label: 'A.G.F. ASS. GEN. DE FRANC. - 149' },
  { key: '150', label: 'UNIONE EURO AMERICANA DI ASS.NI - L.C.A.- - 150' },
  { key: '151', label: 'GROUPAMA ASSICURAZIONI - 151' },
  { key: '154', label: 'REALE RIASSICURAZIONI - 154' },
  { key: '158', label: 'ARAG - 158' },
  { key: '159', label: 'FIRS ITALIANA DI ASSICURAZIONI SPA - L.C.A.- - 159' },
  { key: '160', label: 'LATINA VITA - 160' },
  { key: '162', label: 'LLOYD ITALIANO - L.C.A.- - 162' },
  { key: '164', label: 'FUSA IN UNIPOL(EX MEIEAURORA/AURORA/SIAD/COM.MERID - 164' },
  { key: '166', label: 'FIDEUROPA - 166' },
  { key: '169', label: 'HELVETIA (EX ASSINT ASSICURAZIONI INTERNAZIONALI) - 169' },
  { key: '170', label: 'NATIONAL VULCAN - 170' },
  { key: '172', label: 'UNIQA PROTEZIONE (EX LA CARNICA S.P.A.) - 172' },
  { key: '174', label: 'ALPI ASSICURAZIONI - L.C.A.- - 174' },
  { key: '175', label: 'SIAT - 175' },
  { key: '176', label: 'VITA COMPAGNIA DI ASSICURAZIONI SULLA VITA S.A. - 176' },
  { key: '177', label: 'DELTA SPA-COMPAGNIA DI ASS.NI E RIASS.NI - L.C.A.- - 177' },
  { key: '178', label: 'EURITASS - 178' },
  { key: '179', label: 'FUSA IN UNIPOL(EX MEIEAURORA/AURORA/SIAD/CO.SI.DA) - 179' },
  { key: '181', label: 'RSA (EX THE CENTURY INSURANCE CO.) - 181' },
  { key: '183', label: 'ITAS VITA - 183' },
  { key: '186', label: 'FUSA IN UNIPOL(EX NAVALE/MERCURY/CAB/MMI DANNI) - 186' },
  { key: '187', label: 'FUSA IN UNIPOL(EX NAVALE/FIDUCIARIA/CAB/MMI DANNI) - 187' },
  { key: '188', label: 'LA CONCORDIA DI ASS.NI E RIASS.NI - 188' },
  { key: '189', label: 'AACHENER UND MUNCHENER VERSICHERUNG - L.C.A.- - 189' },
  { key: '191', label: 'SYSTEMA COMPAGNIA DI ASS.NI (EX R+V ALLGEMEINE V.) - 191' },
  { key: '193', label: 'WINTERTHUR VITA - 193' },
  { key: '195', label: 'AUSONIA VITA - 195' },
  { key: '197', label: 'ALLIANZ RAS (EX COMPAGNIA DI GENOVA) - 197' },
  { key: '198', label: 'ZURITEL - 198' },
  { key: '199', label: 'ALLIANZ RAS (EX BERNESE ASSICURAZIONI) - 199' },
  { key: '204', label: 'ITALIANA ASS.NI S.P.A. -LINEA UNIVERSO- - 204' },
  { key: '205', label: 'ACE EUROPEAN GROUP LTD (EX ACE ITALY) - 205' },
  { key: '206', label: 'GAN VIE - 206' },
  { key: '207', label: 'FUSA IN UNIPOL(EX MEIEAURORA/AURORA/SIAD/EUROLLOYD - 207' },
  { key: '208', label: 'NATIONALE SUISSE - 208' },
  { key: '209', label: 'AMBRA (EX LA PENINSULARE) - 209' },
  { key: '211', label: 'LA FONDIARIA (EX C.I.D.A.S / GLOBO) - 211' },
  { key: '212', label: 'LE ASSICURAZIONI DI ROMA - 212' },
  { key: '213', label: 'CARIGE VITA NUOVA - 213' },
  { key: '214', label: 'DUOMO UNI ONE ASS.NI (EX UNIASS/GIOVE ROMA) - 214' },
  { key: '215', label: 'DUOMO UNI ONE ASS.NI (EX UNIASS/COMP.EUR.DI PREV.) - 215' },
  { key: '217', label: 'MEDIOLANUM VITA - 217' },
  { key: '218', label: 'HDI-GERLING INDUSTRIE VERSICHERUNG AG. - 218' },
  { key: '219', label: 'FUSA IN UNIPOL(EX AURORA/MULTIASS/PAN-ASS) - 219' },
  { key: '220', label: 'MILANO ASS.NI (EX AUSONIA) - 220' },
  { key: '222', label: 'ALA ASSICURAZIONI SPA (EX S.E.A.R.) - 222' },
  { key: '223', label: 'ITAS ASSICURAZIONI S.P.A. - 223' },
  { key: '225', label: 'LA DIFESA - 225' },
  { key: '226', label: 'S.L.P. * - 226' },
  { key: '227', label: 'SANREMO - 227' },
  { key: '228', label: 'MILANO ASS.NI (EX ITALIANA/BAVARIA) - 228' },
  { key: '229', label: 'MILANO ASS.NI (EX LOMBARDA) - 229' },
  { key: '230', label: 'DUOMO UNI ONE ASS.NI (EX UNIASS/ETRUSCA) - 230' },
  { key: '231', label: 'AMBRA (EX UNICA ASSICURAZIONI) - 231' },
  { key: '232', label: 'AXA MPS ASSICURAZIONI VITA - 232' },
  { key: '234', label: 'DUOMO UNI ONE ASS.NI (EX UNIASS/TRANS-ATLANTICA) - 234' },
  { key: '235', label: 'COMPAGNIA SILE - ASSICURAZIONI S.P.A. - 235' },
  { key: '237', label: 'GENERTEL SPA (EX RISPARMIO ASS.NI) - 237' },
  { key: '238', label: 'COMAR ASSICURAZIONI SPA - L.C.A.- - 238' },
  { key: '240', label: 'COLOMBO - 240' },
  { key: '241', label: 'LINEAR LIFE - 241' },
  { key: '242', label: 'FUSA IN UNIPOL(EX MEIEAURORA/AURORA/SIAD/SAER) - 242' },
  { key: '243', label: 'AXA MPS ASSICURAZIONI DANNI - 243' },
  { key: '244', label: 'VENETA VITA - 244' },
  { key: '247', label: 'GENERTEL - 247' },
  { key: '249', label: 'FUSA IN UNIPOL(EX MEIEAURORA/S.I.A.D.) - 249' },
  { key: '250', label: 'MAECI VITA (EX NORIMBERGA MAECI VITA S.P.A.) - 250' },
  { key: '251', label: 'MILANO ASS.NI (EX C.A.R.D.) - 251' },
  { key: '253', label: 'AXA ASSICURAZIONI (EX UNITALIA/ALLSECURES) - 253' },
  { key: '254', label: 'ASSIMOCO - 254' },
  { key: '255', label: 'COMMERCIAL UNION ITALIA - 255' },
  { key: '256', label: 'IL SOLE ASS.NI E RIASS.NI - L.C.A.- - 256' },
  { key: '259', label: 'LA FONDIARIA (EX POLARIS/CIDAS DOPPIONE) - 259' },
  { key: '260', label: 'AVON INS.CO.LTD - 260' },
  { key: '261', label: 'POHJOLA INS CO LTD - 261' },
  { key: '262', label: 'THE MUTUAL FIRE MARINE AND INLAND - 262' },
  { key: '263', label: 'RB VITA (EX ITALICA DIVAL VITA) - 263' },
  { key: '264', label: 'ASSIOLIMPIA SPA - 264' },
  { key: '265', label: 'EQUINE & LIVESTOCK - 265' },
  { key: '266', label: 'WURTTEMBERGISCHE FEUERVERSICHERUNG - 266' },
  { key: '267', label: 'TOKIO MARINE KILN INSURANCE LIMITED * - 267' },
  { key: '268', label: 'PHOENIX ASSURANCE CP0. LTD. - 268' },
  { key: '269', label: 'COMMERCIAL UNION ITALIA (EX C.U.INSURANCE/GEAS) - 269' },
  { key: '270', label: 'HELVETIA (EX COLONIA VERSICHERUNGS) - 270' },
  { key: '271', label: 'LA FONDIARIA (EX POLARIS/SIPEA) - 271' },
  { key: '273', label: 'ABC ASSICURA - 273' },
  { key: '274', label: 'PROGRESS ASSICURAZIONI SPA - L.C.A.- - 274' },
  { key: '275', label: 'GENERALI ITALIA / DIVISIONE AUGUSTA - 275' },
  { key: '276', label: 'THE CONTINENTAL INS. CO. - L.C.A.- - 276' },
  { key: '278', label: 'DUOMO PREVIDENZA (EX MGF VITA ITALIA) - 278' },
  { key: '279', label: 'BERNESE VITA - 279' },
  { key: '280', label: 'AMBRA ASSICURAZIONI - L.C.A.- - 280' },
  { key: '281', label: 'INCONTRA ASSICURAZIONI - 281' },
  { key: '282', label: 'FARO ASSICURAZIONI (EX NORD DEUTSCHE) - 282' },
  { key: '283', label: 'DUOMO UNI ONE ASS.NI (EX UNI ONE) - 283' },
  { key: '284', label: 'GENERALI ITALIA / DIVISIONE LLOYD ITALICO - 284' },
  { key: '285', label: 'ALLIANZ RECHTSSCHUTZ - 285' },
  { key: '286', label: 'ITALIANA ASS.NI S.P.A. (EX UNIVERSO VITA) - 286' },
  { key: '287', label: 'RSA - PTF EX AGF - - 287' },
  { key: '288', label: 'GOTHAER VERSICHERUNGSBANK VVAG - 288' },
  { key: '289', label: 'GAN ITALIA S.P.A. (EX GAN INCENDIE ACCIDENTS) - 289' },
  { key: '290', label: 'PRIME AUGUSTA VITA SPA - 290' },
  { key: '292', label: 'HELVETIA ITALIA ASSICURAZIONI S.p.A. - 292' },
  { key: '293', label: 'ERGO ASSICURAZIONI - 293' },
  { key: '294', label: 'SARA VITA - 294' },
  { key: '295', label: "LLOYD'S * - 295" },
  { key: '296', label: 'LA FENICE - 296' },
  { key: '297', label: 'AMERICAN FAMILY LIFE - 297' },
  { key: '298', label: 'MEIE VITA - 298' },
  { key: '299', label: 'FUSA IN UNIPOL(EX AURORA/NEW WIN/MULTIASS ASS.NI) - 299' },
  { key: '300', label: 'MAGDEBURGER RECHTSSCHUTZ - 300' },
  { key: '301', label: 'MAGDEBURGER LEBENS - 301' },
  { key: '302', label: 'SANPAOLO VITA (EX POLARIS VITA) - 302' },
  { key: '304', label: 'CARGEAS ASSICURAZIONI - 304' },
  { key: '305', label: 'AXA INTERLIFE - 305' },
  { key: '306', label: 'INTESA SANPAOLO VITA * - 306' },
  { key: '307', label: 'QUADRIFOGLIO VITA (EX C.IA ASS.LAVORO&PREVIDENZA) - 307' },
  { key: '308', label: 'MAA VITA - 308' },
  { key: '309', label: 'HELVETIA VITA - 309' },
  { key: '310', label: 'LEGAL AND GENERAL ASSURANCE SOCIETY LTD - 310' },
  { key: '311', label: 'ALLIANZ RAS (EX RAS TUTELA GIUDIZIARIA) - 311' },
  { key: '312', label: 'MILANO ASS.NI (EX NUOVA MAA/SIS) - 312' },
  { key: '313', label: 'FUSA IN UNIPOL(EX MEIEAURORA/MEIE/RISCHI DIVERSI) - 313' },
  { key: '315', label: 'SYSTEMA COMPAGNIA DI ASSICURAZIONI - 315' },
  { key: '317', label: 'NATIONALE SUISSE VITA - 317' },
  { key: '319', label: 'BNL VITA - 319' },
  { key: '320', label: 'COMMERCIAL UNION PREVIDENZA (EX SYSTEMA VITA) - 320' },
  { key: '321', label: 'SARP - L.C.A.- - 321' },
  { key: '323', label: 'AVIVA VITA - 323' },
  { key: '324', label: 'NOVARA VITA (EX SIAT VITA SPA) - 324' },
  { key: '325', label: 'AXA ASSICURAZIONI (EX CENTURION) - 325' },
  { key: '326', label: 'HDI ASSICURAZIONI S.P.A. (EX LA MANNHEIM) - 326' },
  { key: '327', label: 'ASSICURATRICE MILANESE - 327' },
  { key: '328', label: 'COFACE COMPAGNIA DI ASS.E RIASS.(EX LA VISCONTEA) - 328' },
  { key: '330', label: 'AVIVA ASSICURAZIONI VITA - 330' },
  { key: '333', label: 'FIDEURAM - 333' },
  { key: '334', label: 'ASSID - ASSICURATRICE ITALIANA DANNI - L.C.A. - 334' },
  { key: '335', label: "D'EASS S.P.A. DI ASS.NI E RIASS.NI - L.C.A.- - 335" },
  { key: '338', label: 'NORD EST ASSICURAZIONI - L.C.A.- - 338' },
  { key: '342', label: 'UNISALUTE S.P.A. - 342' },
  { key: '343', label: 'ALLIANZ RAS (EX ASS.CE ITALIANA DANNI/COMMERCIO) - 343' },
  { key: '344', label: 'AIG EUROPE LTD - 344' },
  { key: '346', label: 'CREDITRAS ASS.NI (EX ADRIATICA DANNI) - 346' },
  { key: '351', label: 'LA REUNION FRANCAISE - 351' },
  { key: '352', label: 'AVIVA ITALIA - 352' },
  { key: '354', label: 'BL CONSULENZE SRL (EX LIMMAT) - 354' },
  { key: '356', label: 'AZZURRA ASSICURAZIONI SPA - 356' },
  { key: '358', label: 'ALLIANZ RAS (EX ASSICURATRICE ITALIANA VITA) - 358' },
  { key: '359', label: 'ZURIGO (EX ZURICH INTERNATIONAL ITALIA SPA) - 359' },
  { key: '360', label: 'CREDITRAS ASS.NI (EX DUERREVITA) - 360' },
  { key: '363', label: 'ANTONIANA VENETA POPOLARE VITA - 363' },
  { key: '364', label: 'ANTONIANA VENETA POPOLARE ASS.NI (EX GIULIANA) - 364' },
  { key: '366', label: 'DUOMO UNI ONE ASS.NI (EX MAECI S.P.A.) - 366' },
  { key: '370', label: 'MUNCHENER RUCK ITALIA SPA - 370' },
  { key: '371', label: 'INTESAVITA S.P.A. - 371' },
  { key: '374', label: 'MUNICIPAL GENERAL INS. LTD - 374' },
  { key: '377', label: 'ESPERIA ASSICURAZIONI S.P.A. - 377' },
  { key: '378', label: 'AVIVA ASS.NI (EX COMMERCIAL UNION) - 378' },
  { key: '380', label: 'EUROSUN ASSICURAZIONI VITA SPA - 380' },
  { key: '381', label: 'ERGO PREVIDENZA - 381' },
  { key: '385', label: 'C.B.A. VITA - 385' },
  { key: '386', label: 'FARO ASSICURAZIONI - 386' },
  { key: '387', label: 'TICINO VITA (EX SWISS LIFE (ITALIA)) - 387' },
  { key: '388', label: 'ASSIBA - 388' },
  { key: '390', label: 'EUROP ASSISTANCE ITALIA - 390' },
  { key: '392', label: 'ALA ASSICURAZIONI - 392' },
  { key: '395', label: 'GLOBAL ASSISTANCE - 395' },
  { key: '396', label: 'MONDIAL ASSISTANCE ITALIA (EX ELVIA ITALIA) - 396' },
  { key: '399', label: 'INTER PARTNER ASSISTANCE S.A. - 399' },
  { key: '400', label: 'FILO DIRETTO - 400' },
  { key: '401', label: 'GENERALI ITALIA / DIVISIONE TORO TARGA - 401' },
  { key: '408', label: 'ALICO (EX AIG VITA/UNIONVITA) - 408' },
  { key: '409', label: 'MEDITAL ASSISTANCE SPA - 409' },
  { key: '410', label: 'MILANO ASS.NI (EX NUOVA M.A.A.) - 410' },
  { key: '412', label: 'ITALIANA ASS.NI (EX LA PIEMONTESE) - 412' },
  { key: '416', label: 'COMPAGNIA ASSICURATRICE LINEAR - 416' },
  { key: '417', label: 'ARCA ASSICURAZIONI - 417' },
  { key: '418', label: 'BCC ASSICURAZIONI - 418' },
  { key: '419', label: 'INTESA SANPAOLO ASSICURA S.p.A. - 419' },
  { key: '422', label: 'SASA VITA - 422' },
  { key: '423', label: 'CREDITRAS ASS.NI (EX CASSE E ASSICURAZIONI VITA) - 423' },
  { key: '424', label: 'CENTROVITA ASSICURAZIONI C/O INTESA S.PAOLO VITA - 424' },
  { key: '426', label: 'CNP UNICREDIT VITA - 426' },
  { key: '428', label: 'CREDEMASSICURAZIONI - 428' },
  { key: '429', label: 'TUA ASSICURAZIONI - 429' },
  { key: '432', label: 'DIRECT LINE INSURANCE - 432' },
  { key: '436', label: 'GENERALI VITA SPA - 436' },
  { key: '440', label: 'AXA GLOBAL DIRECT SEGUROS Y REASEGUROS S.A.U. - 440' },
  { key: '441', label: 'NET INSURANCE S.p.A. - 441' },
  { key: '444', label: 'REM ASSICURAZIONI S.P.A. - 444' },
  { key: '445', label: 'GENERTELLIFE - 445' },
  { key: '446', label: 'ISTITUTO NAZIONALE DELLE ASSICURAZIONI - INA VITA - 446' },
  { key: '448', label: 'CHIARA VITA - 448' },
  { key: '449', label: 'BCC VITA * - 449' },
  { key: '452', label: 'CATTOLICA PREVIDENZA - 452' },
  { key: '455', label: 'SACE BT - 455' },
  { key: '456', label: 'ARFIN COMPAGNIA DI ASS.NI E RIASS.NI - 456' },
  { key: '457', label: 'AVIPOP ASSICURAZIONI - 457' },
  { key: '458', label: 'INCHIARO ASSICURAZIONI - 458' },
  { key: '466', label: 'NOVIT ASSICURAZIONI S.P.A. - L.C.A.- - 466' },
  { key: '468', label: 'RBM SALUTE - 468' },
  { key: '469', label: 'ARISCOM COMPAGNIA DI ASSICURAZIONI - 469' },
  { key: '471', label: 'BANCASSURANCE POPOLARI DANNI - 471' },
  { key: '472', label: 'CRÉDIT AGRICOLE ASSICURAZIONI - 472' },
  { key: '474', label: 'NOBIS COMPAGNIA DI ASSICURAZIONI - 474' },
  { key: '479', label: 'FIDEURAM VITA * - 479' },
  { key: '480', label: 'POSTE ASSICURA - 480' },
  { key: '482', label: 'BIPIEMME ASSICURAZIONI - 482' },
  { key: '483', label: 'ASSICURAZIONI GENERALI - 483' },
  { key: '484', label: 'ALLEANZA ASSICURAZIONI S.p.A. - 484' },
  { key: '486', label: 'BENE ASSICURAZIONI S.P.A. - 486' },
  { key: '600', label: 'SOGESSUR S.A. - 600' },
  { key: '601', label: 'MAPFRE RE COMPANIA DE REASEGUROS SA * - 601' },
  { key: '602', label: 'TORUS INSURANCE (UK) Limited * - 602' },
  { key: '605', label: 'ROYAL & SUN ALLIANCE INSURANCE plc * - 605' },
  { key: '608', label: 'LIBERTY MUTUAL INSURANCE EUROPE LTD * - 608' },
  { key: '610', label: 'AMTRUST EUROPE LIMITED - 610' },
  { key: '618', label: 'METLIFE EUROPE LIMITED - 618' },
  { key: '620', label: "GROUPAMA S.A. RAPPRESENTANZA GENERALE PER L'ITALIA - 620" },
  { key: '625', label: 'MSIG INSURANCE EUROPE AG * - 625' },
  { key: '800', label: 'SOMPO JAPAN INS. CO. OF EUROPE LTD. * - 800' },
  { key: '815', label: 'AXA CORPORATE SOLUTIONS ASSURANCE - 815' },
  { key: '816', label: 'ATRADIUS CREDIT INSURANCE N.V. - 816' },
  { key: '817', label: 'SWISS RE EUROPE S.A. - 817' },
  { key: '818', label: 'XL INSURANCE COMPANY SE - 818' },
  { key: '828', label: 'UNIQA OSTERREICH VERSICHERUNGEN AG * - 828' },
  { key: '830', label: 'AXA ART VERSICHERUNG AG * - 830' },
  { key: '838', label: 'NIPPONKOA INSURANCE COMPANY (EUROPE) * - 838' },
  { key: '839', label: 'FM INSURANCE COMPANY LIMITED * - 839' },
  { key: '853', label: 'ACE EUROPEAN GROUP LIMITED - 853' },
  { key: '857', label: 'CNA INSURANCE COMPANY LTD * - 857' },
  { key: '859', label: 'GAN EUROCOURTAGE DIVISIONE GROUPAMA TRANSPORT - 859' },
  { key: '864', label: 'ZURICH INSURANCE PLC - 864' },
  { key: '869', label: 'DONAU VERSICHERUNG AG VIENNA INSURANCE - 869' },
  { key: '872', label: 'AIOI NISSAY DOWA INS. CO. OF EUROPE - 872' },
  { key: '873', label: 'QBE INSURANCE (EUROPE) LIMITED - 873' },
  { key: '874', label: 'SCOR GLOBAL P&C S.E. - 874' },
  { key: '880', label: 'ALLIANZ GLOBAL CORPORATE & SPECIALTY * - 880' },
  { key: '883', label: 'CHUBB INSURANCE COMPANY OF EUROPE SE - 883' },
  { key: '886', label: 'SWISS RE INTERNATIONAL SE - 886' },
  { key: '899', label: 'GREAT LAKES REINSURANCE (UK) PLC - 899' },
  { key: '906', label: 'PROBUS INSURANCE COMPANY EUROPE LTD. - 906' },
  { key: '909', label: 'EURO INSURANCES LIMITED - 909' },
  { key: '911', label: 'ADMIRAL INSURANCE COMPANY LIMITED - 911' },
  { key: '915', label: 'COVEA FLEET S.A. - 915' },
  { key: '944', label: 'UNION ASS. PARIS I VIE - 944' },
  { key: '955', label: 'LA PARISIENNE S.A. - 955' },
  { key: '962', label: 'HOK OSIGURANJE D.D.- HRVATSKA OSIGURAVAJU?A KU?A - 962' },
  { key: '990', label: "LLOYD'S CROWE SYNDICATE 963 - 990" },
  { key: '999', label: 'COMPAGNIA NON IDENTIFICATA - 999' },
  { key: 'AMO', label: 'ASSICURAZIONI GENERALI-DIR.MOGLIANO-MIGRAZIONE - AMO' },
  { key: 'B00', label: "LLOYD'S UNDERWRITERS - C/O WILLIS ITALIA SPA - B00" },
  { key: 'B01', label: 'BANCHERO COSTA & C. - B01' },
  { key: 'B02', label: 'NORWICH UNION FIRE INS. - B02' },
  { key: 'E02', label: 'ALLIANZ VERSICHERUNGS AG - E02' },
  { key: 'E06', label: 'TRENWICK INTERNATIONAL LTD - E06' },
  { key: 'E0A', label: "LLOYD'S SYNDICATE 5000 TRAVELERS - E0A" },
  { key: 'E0B', label: "LLOYD'S SYNDICATE 3902-ARK - E0B" },
  { key: 'E0C', label: 'ALLIED WORLD ASS.SERV.LONDON - E0C' },
  { key: 'E0D', label: 'LA REUNION AERIENNE LONDON LTD(EX ROBERT MALATIER) - E0D' },
  { key: 'E0E', label: "LLOYD'S SYNDICATE 0510 - KLN 510 KILN - - E0E" },
  { key: 'E0F', label: "LLOYD'S SYNDICATE BAR 1955 (BARBICAN) - E0F" },
  { key: 'E0G', label: 'HELVETIA SCHWEIZERISCHE LEBENSVERSICHERUNGSGESELLS - E0G' },
  { key: 'E0H', label: 'HDI-GERLING INDUSTRIE VERSICHERUNG AG-GRECIA - E0H' },
  { key: 'E0I', label: 'AXIS SPECIALTY EUROPE SE - E0I' },
  { key: 'E0J', label: 'Q.B.E. INSURANCE (EUROPE) LTD - E0J' },
  { key: 'E0K', label: "LLOYD'S SYNDICATE 3010-CATHEDRAL UNDERWRITING LTD - E0K" },
  { key: 'E0L', label: 'ABU DHABI NATIONAL INSURANCE CO - E0L' },
  { key: 'E0M', label: 'KOREAN REINSURANCE COMPANY - E0M' },
  { key: 'E0N', label: 'ENDURANCE WORLDWIDE INSURANCE LIMITED - E0N' },
  { key: 'E0O', label: "LLOYD'S SYNDICATE 4711 ASP - E0O" },
  { key: 'E0P', label: 'FIDELIS INSURANCE BERMUDA LIMITED - E0P' },
  { key: 'E0Q', label: "LLOYD'S SYNDICATE 1414-ASCOT UNDERWRITING LIMITED - E0Q" },
  { key: 'E0R', label: 'HELVETIA ASSURANCES SA - E0R' },
  { key: 'E0S', label: 'GENERAL INSURANCE CORPORATION OF INDIA - E0S' },
  { key: 'E0T', label: 'CODAN FORSIKRING A/S - E0T' },
  { key: 'E0U', label: 'SWISS LIFE ASSURANCE ET PATRIMOINE (F) - E0U' },
  { key: 'E0V', label: 'NAVIGATORS INSURANCE CO. U.S.A. - E0V' },
  { key: 'E0W', label: 'SWISS RE INTERNATIONAL SE - E0W' },
  { key: 'E0X', label: 'ALLIANZ, CIA DE SEGUROS Y REASEGUROS SA - E0X' },
  { key: 'E0Y', label: "LLOYD'S SYNDICATE 4472 - LIB 4472 LIBERTY - - E0Y" },
  { key: 'E0Z', label: "LLOYD'S SYNDICATE 1183 - TAL 1183 TALBOT - - E0Z" },
  { key: 'E11', label: 'CNA INSURANCE COMPANY LTD - EUROPEAN HEAD OFFICE - E11' },
  { key: 'E14', label: 'INTERUNFALL VERSICHERUNG AKTIENGESELLSCHAFT - E14' },
  { key: 'E18', label: 'WUERTTEMBERGISCHE VERSICHERUNG AG - E18' },
  { key: 'E1A', label: "LLOYD'S SYNDICATE 0457 - WTK 457 WATKINS - E1A" },
  { key: 'E1B', label: "LLOYD'S SYNDICATE 4444 - CNP 4444 CANOPIUS - - E1B" },
  { key: 'E1C', label: "LLOYD'S SYNDICATE 3000 - MKL 3000 MARKEL - - E1C" },
  { key: 'E1D', label: "LLOYD'S SYNDICATE 1301 SCC - E1D" },
  { key: 'E1E', label: "LLOYD'S SYNDICATE 1967 - BERKLEI 1967 - - E1E" },
  { key: 'E1F', label: 'STARR INSURANCE & REINSURANCE LTD - E1F' },
  { key: 'E1G', label: 'ASIA CAPITAL REINSURANCE GROUP PTE. LTD. - E1G' },
  { key: 'E1J', label: 'FUBON INSURANCE CO. LTD - E1J' },
  { key: 'E1K', label: 'SIRIUS INTERNATIONAL INS.CO.(PUBL)-ZURICH BRANCH - E1K' },
  { key: 'E1L', label: 'ERGO INSURANCE PTE LTD - E1L' },
  { key: 'E1M', label: 'MISR INSURANCE COMPANY - E1M' },
  { key: 'E1N', label: 'NEW INDIA ASSURANCE - E1N' },
  { key: 'E1O', label: 'IRB-BRASIL RESSEGUROS S.A. - E1O' },
  { key: 'E1P', label: 'HCC INTERNATIONAL INSURANCE COMPANY PLC - E1P' },
  { key: 'E1Q', label: 'CHUBB INSURANCE COMPANY OF EUROPE SE - E1Q' },
  { key: 'E1R', label: 'INTERNATIONAL GENERAL INSURANCE - E1R' },
  { key: 'E1S', label: 'STARR INTERNATIONAL (EUROPE) LIMITED - E1S' },
  { key: 'E1T', label: 'XL INSURANCE COMPANY SE - PARIS - - E1T' },
  { key: 'E1U', label: "LLOYD'S SYNDICATE 2468 NEON - E1U" },
  { key: 'E1V', label: 'ELSECO LIMITED - E1V' },
  { key: 'E1W', label: 'HDI GLOBAL SE (EX HDI-GERLING INDUSTRIE VERS. AG) - E1W' },
  { key: 'E1X', label: 'HELVETIA SWISS INSURANCE COMPANY-LIECHTENSTEIN LTD - E1X' },
  { key: 'E1Y', label: 'SCOR GLOBAL P&C S.E.-FRANCIA - E1Y' },
  { key: 'E1Z', label: "LLOYD'S SYNDICATE 1686-AXIS MANAGING AGENCY LTD - E1Z" },
  { key: 'E20', label: 'ENI INSURANCE DAC (DESIGNATED ACTIVITY COMPANY) - E20' },
  { key: 'E21', label: 'CATLIN INSURANCE COMPANY UK - E21' },
  { key: 'E22', label: 'AIG UK LIMITED - E22' },
  { key: 'E23', label: 'SR INTERNATIONAL BUSINESS INS. C/O SWISS - E23' },
  { key: 'E24', label: 'GENERALA SOC. ROMANA DE ASIGUR - E24' },
  { key: 'E25', label: 'ALLIANZ GLOBAL CORPORATE & SPECIALTY AG - E25' },
  { key: 'E26', label: 'LA REUNION AERIENNE - E26' },
  { key: 'E29', label: 'GENERALI FRANCE ASSURANCES - E29' },
  { key: 'E2A', label: "LLOYD'S SYNDICATE 2121 ARGENTA - E2A" },
  { key: 'E2B', label: "LLOYD'S SYNDICATE 2232-ALLIED WORLD MANAGING AG. - E2B" },
  { key: 'E2C', label: "LLOYD'S SYNDICATE 1110-PROSIGHT SPECIALTY UNDERWR. - E2C" },
  { key: 'E2D', label: "LLOYD'S SYNDICATE 2623-BEAZLEY FURLONGE LIMITED - E2D" },
  { key: 'E2E', label: "LLOYD'S SYNDICATE 2007-NOVAE - E2E" },
  { key: 'E2F', label: "LLOYD'S SYNDICATE 1036-QBE UNDERWRITING LIMITED - E2F" },
  { key: 'E2G', label: "LLOYD'S SYNDICATE 0623-BEAZLEY FURLONGE LIMITED - E2G" },
  { key: 'E2H', label: 'CHINA TAIPING INSURANCE (UK) CO LIMITED - E2H' },
  { key: 'E30', label: 'XL LONDON MARKET, SYNDICATE 1209 - E30' },
  { key: 'E31', label: 'NEPTUNIA MARINE INS. LTD. - E31' },
  { key: 'E32', label: 'GROUPAMA NORD-EST - E32' },
  { key: 'E33', label: 'CHARTIS EUROPE S.A. (DIR DEUTSCHLAND) - E33' },
  { key: 'E34', label: 'GENERALI VERSICHERUNG AG - E34' },
  { key: 'E35', label: 'TOKIO MARINE EUROPE INSURANCE LTD - E35' },
  { key: 'E36', label: 'GROUPAMA TRANSPORT SA - E36' },
  { key: 'E37', label: 'INFRASSURE LIMITED - E37' },
  { key: 'E38', label: 'SWISS RE INTERNATIONAL SE - UK BRANCH - - E38' },
  { key: 'E39', label: 'INTERNATIONAL INSURANCE COMPANY OF HANNOVER LTD - E39' },
  { key: 'E40', label: 'SCOR UK COMPANY LIMITED - E40' },
  { key: 'E41', label: 'AXA CORPORATE SOLUTIONS ASSURANCE S.A. - E41' },
  { key: 'E42', label: 'GREAT LAKES REINSURANCE (UK) LIMITED - E42' },
  { key: 'E43', label: 'MAPFRE GLOBAL RISKS - E43' },
  { key: 'E45', label: 'SWISSLIFE PREVOYANCE ET SANTE - E45' },
  { key: 'E46', label: 'HDI GLOBAL SE - E46' },
  { key: 'E47', label: 'PAN INSURANCE LIMITED - E47' },
  { key: 'E48', label: 'VIENNA INSURANCE GROUP AG WIENER VERSICHERUNG GRUP - E48' },
  { key: 'E49', label: 'BERKSHIRE HATHAWAY INTERNATIONAL INSURANCE LIMITED - E49' },
  { key: 'E50', label: 'ERGO VERSICHERUNG AG - E50' },
  { key: 'E51', label: 'SCOR CHANNEL LTD - E51' },
  { key: 'E52', label: 'AXA CORPORATE SOLUTION UK - E52' },
  { key: 'E53', label: 'FORTIS CORPORATE INSURANCE N.V. - E53' },
  { key: 'E54', label: 'THOMPSON HEATH & BOND LTD - E54' },
  { key: 'E55', label: 'CATLIN ITALIA BRANCH OF CATLIN GMBH - E55' },
  { key: 'E56', label: "LLOYD'S SYNDICATE MLM 1221-NAVIGATORS UNDERWRITING - E56" },
  { key: 'E57', label: 'AXA GLOBAL RISKS - E57' },
  { key: 'E58', label: 'GARD MARINE & ENERGY LTD - E58' },
  { key: 'E59', label: 'GLOBAL AEROSPACE UNDERWITING MANAGERS - GAUM POOL - E59' },
  { key: 'E5E', label: 'CATLIN ITALIA-BRANCH OF CATLIN GMBH - E5E' },
  { key: 'E60', label: "LLOYD'S SYNDICATE 1200 - AMA 1200 ARGO - - E60" },
  { key: 'E61', label: "LLOYD'S SYNDICATE 2003 - SJC 2003 CATLIN - E61" },
  { key: 'E62', label: "LLOYD'S SYNDICATE 2001 - AML 2001 AMLIN - - E62" },
  { key: 'E63', label: "LLOYD'S SYNDICATE 1274 - AUL 1274 ANTARES - - E63" },
  { key: 'E64', label: "LLOYD'S SYNDICATE 2488 - AGM 2488 ACE - - E64" },
  { key: 'E65', label: 'ALLIANZ GLOBAL CORPORATE & SPECIALTY AG -UK BRANCH - E65' },
  { key: 'E66', label: 'AIG EUROPE LTD - E66' },
  { key: 'E67', label: 'SWISS RE EUROPE S.A. - GERMAN BRANCH - E67' },
  { key: 'E68', label: 'MUENCHENER RUECKVERSICHERUNGS-GESELLSCHAFT AG - E68' },
  { key: 'E69', label: 'MITSUI MARINE AND FIRE (EUROPE) - E69' },
  { key: 'E71', label: 'AVIVA INTERNATIONAL INSURANCE LIMITED - E71' },
  { key: 'E72', label: 'BASLER VERSICHERUNG AG DIREKTION FðR DEUTSCHLAND - E72' },
  { key: 'E73', label: 'ENEL INSURANCE N.V. - E73' },
  { key: 'E74', label: 'ROYAL & SUN ALLIANCE INS PLC - E74' },
  { key: 'E75', label: 'STARSTONE INSURANCE EUROPE AG (EX TORUS) - E75' },
  { key: 'E76', label: 'LANCASHIRE INSURANCE COMPANY (UK) LIMITED - E76' },
  { key: 'E77', label: 'CASTEL UNDERWRITING AGENCIES LIMITED TRADING - E77' },
  { key: 'E78', label: 'PARTNERRE IRELAND INSURANCE LTD - E78' },
  { key: 'E79', label: "AVIABEL COMPAGNIE BELGE D'ASSURANCE AVIATION S.A. - E79" },
  { key: 'E80', label: 'CHUBB EUROPEAN GROUP LTD. (EX ACE) - E80' },
  { key: 'E81', label: 'GENERALI VERSICHERUNG AG - E81' },
  { key: 'E82', label: "LLOYD'S SYNDICATE 1919 - CVS 1919 CV STARR - - E82" },
  { key: 'E83', label: "LLOYD'S SYNDICATE 2987 - BRT 2987 BRIT - - E83" },
  { key: 'E84', label: 'OMAN INSURANCE COMPANY - E84' },
  { key: 'E85', label: 'HYUNDAI MARINE AND FIRE INSURANCE COMPANY - E85' },
  { key: 'E86', label: "LLOYD'S OF LONDON - E86" },
  { key: 'E87', label: 'CNA INSURANCE SWITZERLAND - E87' },
  { key: 'E88', label: 'EULER HERMES DEUTSCHLAND A.G. - E88' },
  { key: 'E89', label: "LLOYD'S SYNDICATE 1897 (SKULD) - E89" },
  { key: 'E90', label: "LLOYD'S SYNDICATE 0382 - HDU 382 HARDY - - E90" },
  { key: 'E91', label: 'LIBERTY MUTUAL AVIATION CONSORTIUM - E91' },
  { key: 'E92', label: "LLOYD'S SYNDICATE HISCOX LIMITED (HIS 33) - E92" },
  { key: 'E93', label: 'VHV ALLGEMEINE VERSICHERUNG AG - E93' },
  { key: 'E94', label: "LLOYD'S SYNDICATE 1969 ANV (APOLLO 9219) - E94" },
  { key: 'E95', label: "LLOYD'S SYNDICATE 1861 ANV (APOLLO 9219) - E95" },
  { key: 'E96', label: "LLOYD'S SYNDICATE 1084 CHAUCER - E96" },
  { key: 'E97', label: "LLOYD'S SYNDICATE 0609-AUW 609 ATRIUM - E97" },
  { key: 'E98', label: "LLOYD'S SYNDICATE 1880 TOKIO MARINE - E98" },
  { key: 'EEE', label: 'GENERALI ITALIA MILANO - EEE' },
  { key: 'VNA', label: 'VEICOLO NON ASSICURATO - VNA' },
  { key: 'YXW', label: 'MAPFRE RE COMPANIA DE REASEGUROS-FINMECCANICA 2015 - YXW' },
  { key: 'ZYX', label: 'AXA CORPORATE SOLUTIONS-FINMECCANICA 2015 - ZYX' }
];

export const GERAR_BOX_MAPPINGS = new Map([
  ['MEC', 'MECCANICO'],
  ['AUT', 'AUTOMATICO'],
  ['RID', 'CON RIDUTTORE'],
  ['MLT', 'CON MOLTIPLICATORE'],
  ['CNV', 'CON CONVERTITORE'],
  ['OVD', 'OVER DRIVE'],
  ['ELE', 'ELETTRICO']
]);